import { useEffect, useRef, useState, useCallback, useMemo } from "react";
import Select from 'react-select';
import "../../../node_modules/tabulator-tables/dist/css/tabulator_bootstrap4.css";
import "../../../node_modules/semantic-ui-css/components/icon.min.css";
import { TabulatorFull as Tabulator, ColumnComponent, CellComponent, ColumnDefinition } from "tabulator-tables";
import { RequestMethod } from "../modules/services/core/_enums";
import { IAtivosModel } from "../modules/services/core/_models";
import { getDataSetNamePBI, useHttpClient } from "../modules/services/Bundle";
import moment from "moment"; // Import moment.js
import L from "leaflet";
import { MapContainer, TileLayer, LayersControl } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { useAuth } from "../modules/auth";
import { useLocation } from "react-router-dom";
import { useFiltrosAtivos, FiltroGlobal } from "../../components/FiltrosGlobais";
import GerenciadorArquivos from "../../components/GerenciadorArquivos";



// Correção dos ícones padrão do Leaflet
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.3/dist/images/marker-shadow.png",
});

// Estilos mínimos para footer/paginador do Tabulator (aplicado dinamicamente)
const _tabulatorStyles = `
  .tabulator-footer { background-color: #f8f9fa !important; border-top: 1px solid #e9ecef !important; padding: 8px 12px !important; display: flex !important; justify-content: flex-start !important; }
  /* Forçar o paginador a alinhar à esquerda e ter comportamento consistente */
  .tabulator-paginator { display: inline-flex !important; gap: 6px; align-items: center; margin-left: 0 !important; margin-right: 0 !important; order: 0 !important; justify-content: flex-start !important; }
  .tabulator-footer .tabulator-paginator { align-self: center !important; }
  /* Não ocultar paginadores gerados pelo Tabulator - iremos mover o elemento para o nosso container */
  /* Small page button styles */
  .tabulator-pages { margin: 0 8px; }
  .tabulator-page { border: 1px solid #dee2e6; padding: 4px 8px; border-radius: 4px; background: #fff; color: #333; }
  .tabulator-page.active { background: #0d6efd; color: #fff; border-color: #0d6efd; }
`;
const _styleEl = document.createElement('style');
_styleEl.type = 'text/css';
_styleEl.innerText = _tabulatorStyles;
document.head.appendChild(_styleEl);

// Interface para os chamados/alertas
interface IChamado {
  Status: boolean;
  IdAlertLevel: string;
  Dados: string;
  DataCriacao: string;
  Assunto: string;
  Chamado: string;
  IdWorkFlow: string;
  IdUsuarioOwner: number;
  IdUsuarioResponsible: number;
  UsuarioOwner?: string;
  UsuarioResponsible?: string;
  TotalRecords?: number;
}
interface IMovimentacao {
  tracking: {
    Id: number;
    TrackingDate: Date;
    IdPrism: number;
    Beacon: string;
    Plate: string;
    IdPlaceArrive: number;
    IdPlaceLeave: number;
    PlaceLeave: string;
    PermanenceTime: number;
    Permanence: string;
    IdGateway: number;
    Gateway: string;
    Rssi: number;
    TxPower: string;
    IdOrganization: number;
    latitude: number;
    longitude: number;
    Processo: number;
    IdPlaceArriveNavigation: any | null;
    IdPrismNavigation: any | null;
  };
  place: {
    Id: number;
    Name: string;
    Description: string;
    IdOrganization: number;
    IsNeutralPlace: boolean;
    IsTransitPlace: boolean;
    IsVehicle: boolean;
    Disable: boolean;
    beaconsgroup: any[];
    placealerts: any[];
    placegateway: any[];
    placeorgchanges: any[];
    placetags: any[];
    placeworkflow: any[];
    tracking: any[];
  };
  InfoAdicional: string;
  ItemAssociado: string | null;
  CurrentLastSeen: string | null; // Adicionado para comparação com Última Visualização
}

// Interface para o novo retorno da API TrackingAdjusted
interface ITrackingAdjustedResponse {
  Corporacao: string;
  IdPrism: number;
  Organizacao: string;
  Ativo: string;
  PreviousLastSeen: string | null;
  CurrentLastSeen: string | null;
  StayMinutes: number;
  LastLatitude: number | null;
  LastLongitude: number | null;
  Status: string;
  Local: string;
  ItemAssociado: string | null;
  PosicaoAtual: number;
}

// Interface para usuário
interface IUser {
  Id: number;
  Name: string;
  Email: string;
}

// Interfaces para as APIs de gateway e beacon
interface IExternalPayloadRequest {
  Corporacao?: string;
  Organizacao?: string[];
  Ativos?: string[];
  Interferencia?: number;
  dtfinal?: string;
}

interface IGatewayData {
  Organizacao: string;
  Ativo: string;
  DeviceKey: string;
  LastSeen: string;
  Latitude: number;
  Longitude: number;
  LatitudeAleatoria?: number;
  LongitudeAleatoria?: number;
  GW1?: {
    Id: number;
    Distancia: string;
  };
  Metodo: string;
}

interface IBeaconData {
  Organizacao: string;
  Ativo: string;
  DeviceKey: string;
  LastSeen: string;
  Latitude: number;
  Longitude: number;
  LatitudeAleatoria?: number;
  LongitudeAleatoria?: number;
  GW1?: {
    Id: number;
    Distancia: string;
  };
  Metodo: string;
}

const criarIconeCor = (svg: string) => {
  console.log('🎨 Criando ícone com SVG:', svg.substring(0, 50) + '...');
  return L.icon({
    iconUrl: "data:image/svg+xml;base64," + btoa(svg),
    iconSize: [32, 32]
  });
};

// Utility functions
const isEmpty = (value: any): boolean => {
  const result = value === null || value === undefined || value === '' || value === '0 °C' || value === '0';
  if (result) {
    console.log('🔍 Valor vazio detectado:', value);
  }
  return result;
};

const formatarDataHoraParaAPI = (data: string | Date) => {
  if (typeof data === 'string') {
    data = new Date(data);
  }
  return moment(data).format('YYYY-MM-DDTHH:mm:ss');
};

const AtivoMapaTable: React.FC = () => {
  // hooks e variáveis de estado
  const tableRef = useRef<HTMLDivElement>(null);
  const configTableRef = useRef<HTMLDivElement>(null);
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [detailsVisible, setDetailsVisible] = useState(false);
  const [selectedAtivo, setSelectedAtivo] = useState<IAtivosModel | null>(null);
  const [activeTab, setActiveTab] = useState('mapa');
  const [chamadosAtivo, setChamadosAtivo] = useState<IChamado[]>([]);
  const mainTableRef = useRef<any>(null);
  const configTableRefInstance = useRef<any>(null);
  const mapRef = useRef<L.Map | null>(null);
  const markersGroup = useRef<L.LayerGroup | null>(null);
  const scaleControlRef = useRef<L.Control.Scale | null>(null);
  const currentAtivoMarkerRef = useRef<L.Marker | null>(null);
  const dataSetNamePBI = getDataSetNamePBI();

  const httpClient = useHttpClient();
  const [listaAtivo, setListaAtivo] = useState<IAtivosModel[]>([]);
  const [totalRegistros, setTotalRegistros] = useState<number>(0);
  const [registrosFiltrados, setRegistrosFiltrados] = useState<number>(0);

  // contador de chamadas de API pendentes. quando >0, o botão de configurações fica desabilitado
  const [pendingApiCalls, setPendingApiCalls] = useState<number>(0);
  const startApiCall = useCallback(() => setPendingApiCalls(n => n + 1), []);
  const endApiCall = useCallback(() => setPendingApiCalls(n => Math.max(0, n - 1)), []);
  const configButtonDisabled = pendingApiCalls > 0;

  const [selectedAlert, setSelectedAlert] = useState<IChamado | null>(null);
  const [coments, setComents] = useState<any[]>([]);
  const [newComment, setNewComment] = useState<string>("");
  const [selectedAtivos, setSelectedAtivos] = useState<string[]>([]);
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const [idemail, setIdemail] = useState<number | null>(null);
  const [movimentacoes, setMovimentacoes] = useState<IMovimentacao[]>([]);

  const movimentacoesTableRef = useRef<any>(null);
  const movimentacoesDivRef = useRef<HTMLDivElement>(null);
  const [movimentacoesFiltradas, setMovimentacoesFiltradas] = useState<IMovimentacao[]>([]);
  // Estados para dados de gateway e beacon
  const [gatewayData, setGatewayData] = useState<IGatewayData[]>([]);
  const [beaconData, setBeaconData] = useState<IBeaconData[]>([]);

  const { auth } = useAuth();
  const user = auth?.User;
  const emailUsuario = user?.Email;

  const SCREEN_CODE_TABELA_ATIVOS = "Tabela_Ativos";
  const cacheUserId = auth?.User?.IdUsuario ?? "";

  const extractCacheJson = useCallback((response: any): any => {
    const container = response?.payload ?? response?.data ?? response;
    if (container == null) return null;
    const dataStr = typeof container === "string" ? container : (container?.Data ?? container?.data);
    if (typeof dataStr === "string") {
      try {
        return JSON.parse(dataStr);
      } catch {
        return null;
      }
    }
    if (typeof container === "object" && container !== null) return container;
    return null;
  }, []);

  const saveTableColumnsCache = useCallback(
    async (columnsVisibility: Record<string, boolean>, columnsOrder: string[]) => {
      if (!cacheUserId) return;
      try {
        let current: any = {};
        try {
          const response = await httpClient.request({
            method: RequestMethod.GET,
            endpoint: `/api/Cache/${SCREEN_CODE_TABELA_ATIVOS}?userId=${cacheUserId}`,
          });
          current = extractCacheJson(response) || {};
        } catch {
          // ignore
        }
        const next = { ...current, columnsVisibility, columnsOrder };
        await httpClient.request({
          method: RequestMethod.POST,
          endpoint: "/api/Cache",
          data: {
            UserId: cacheUserId,
            ScreenCode: SCREEN_CODE_TABELA_ATIVOS,
            Data: JSON.stringify(next),
          },
        });
      } catch (e) {
        console.error("Erro ao salvar cache de colunas (Tabela_Ativos).", e);
      }
    },
    [httpClient, extractCacheJson, cacheUserId]
  );

  // Usar filtros globais
  const { selectedOrganizations, isInitialized, selectedCorporation, availableCorporations } = useFiltrosAtivos();


  // Estados para armazenar dados de tracking do ativo selecionado
  const [trackingDataAtivo, setTrackingDataAtivo] = useState<IGatewayData | IBeaconData | null>(null);
  const isVwco = availableCorporations.find(c => c.id === selectedCorporation)?.name === "VWCO";
  // Estado para armazenar a Última Visualização do popup do ativo no mapa
  const [ultimaVisualizacaoPopup, setUltimaVisualizacaoPopup] = useState<string | null>(null);

  // Mover o useLocation para o nível superior
  const location = useLocation();

  // Novo useEffect simplificado para carregar dados quando organizações mudarem
  useEffect(() => {
    if (isInitialized && selectedOrganizations.length > 0) {
      console.log('🔄 Carregando dados para organizações:', selectedOrganizations);
      obterMapaAtivo(selectedOrganizations);
    } else {
      console.log('⏳ Aguardando inicialização ou organizações selecionadas:', { isInitialized, selectedOrganizations });
    }
  }, [selectedOrganizations, isInitialized]);

  async function exportTableToExcel() {
    console.log('📥 Fazendo download do Excel (Dinâmico)');

    if (!mainTableRef.current) {
      console.error("Tabela não inicializada");
      return;
    }

    try {
      // 1. Pegar apenas os dados filtrados/visíveis na tabela
      const filteredData = mainTableRef.current.getData("active");

      // 2. Pegar apenas as colunas visíveis
      const visibleColumns = mainTableRef.current.getColumns()
        .filter((col: ColumnComponent) => col.isVisible());

      console.log('📊 Dados filtrados:', filteredData.length, 'registros');
      console.log('📊 Colunas visíveis:', visibleColumns.length, 'colunas');

      // 3. Mapear os dados usando os títulos que estão na tabela (já traduzidos/configurados)
      const orderedData = filteredData.map((row: any) => {
        const orderedRow: Record<string, any> = {};

        visibleColumns.forEach((col: ColumnComponent) => {
          const def = col.getDefinition();
          const field = col.getField();
          const title = def.title || field; // Pega o título dinâmico configurado

          // Ignora colunas sem field (ex: colunas de botões ou formatação pura)
          if (field) {
            let value = row[field];

            // Tratamento simples para nulos
            if (value === null || value === undefined) {
              value = "";
            }

            orderedRow[title] = value;
          }
        });

        if (row.Latitude !== undefined) {
          orderedRow["Latitude"] = row.Latitude;
        }
        if (row.Longitude !== undefined) {
          orderedRow["Longitude"] = row.Longitude;
        }

        return orderedRow;
      });

      // 5. Enviar para a API de geração do Excel
      const endpoint = `${backendUrl}/Report/Excel`;
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(orderedData)
      });

      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `Ativos_${moment().format('YYYYMMDD_HHmm')}.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        console.log('✅ Arquivo Excel baixado com sucesso!');
      } else {
        console.error('❌ Erro ao baixar o arquivo Excel:', response.statusText);
        alert('Erro ao gerar o arquivo Excel.');
      }
    } catch (error) {
      console.error('❌ Erro ao fazer o POST:', error);
      alert('Erro ao processar a exportação.');
    }
  }

  const handleFecharChamado = async (idWorkFlow: number) => {
    console.log('🔒 Fechando chamado:', idWorkFlow);
    try {
      const response = await fetch(`${backendUrl}/api/PrismWorkflow/Close`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          IdWorkFlow: idWorkFlow,
          Close: true
        }),
      });
      if (response.ok) {
        alert("Chamado fechado com sucesso!");
        // Atualiza o estado do chamado selecionado para fechado
        setSelectedAlert(prev => prev ? { ...prev, Status: true } : prev);
        console.log('✅ Chamado fechado com sucesso');
      } else {
        alert("Erro ao fechar chamado.");
        console.error('❌ Erro ao fechar chamado:', response.statusText);
      }
    } catch (error) {
      alert("Erro ao fechar chamado.");
      console.error('❌ Erro ao fechar chamado:', error);
    }
  };


  useEffect(() => {
    const obterIdEmail = async () => {
      if (emailUsuario) {
        console.log('👤 Obtendo ID do usuário para:', emailUsuario);
        startApiCall();
        try {
          const response = await fetch(
            `${backendUrl}/api/User/ByEmail/${emailUsuario}`,
            {
              method: "GET",
              headers: {
                accept: "*/*",
              },
            }
          );
          const responseJson = await response.json();
          if (typeof responseJson === 'number') {
            setIdemail(responseJson);
            console.log('✅ ID do usuário obtido:', responseJson);
          } else if (responseJson && responseJson.id) {
            setIdemail(responseJson.id);
            console.log('✅ ID do usuário obtido:', responseJson.id);
          }
        } catch (error) {
          console.error('❌ Erro ao obter ID do usuário:', error);
        } finally {
          endApiCall();
        }
      }
    };

    obterIdEmail();
  }, [emailUsuario]);

  const loadConfigTable = () => {
    console.log('⚙️ Carregando tabela de configurações');
    const cols = mainTableRef.current
      .getColumns()
      .map((col: ColumnComponent, index: number) => ({
        id: index + 1,
        title: col.getDefinition().title || col.getField(),
        field: col.getField(),
        visible: col.isVisible(),
      }));

    if (configTableRef.current) {
      if (configTableRefInstance.current) {
        configTableRefInstance.current.destroy();
      }

      configTableRefInstance.current = new Tabulator(configTableRef.current, {
        data: cols,
        layout: "fitDataFill",
        movableRows: true,
        headerVisible: false,
        columns: [
          {
            title: "Mover",
            formatter: "handle",
            headerSort: false,
            width: 30,
            minWidth: 30,
          },
          {
            title: "Coluna",
            field: "title",
            formatter: (cell) => ` ${cell.getValue()}`,
          },
          {
            title: "Visível",
            field: "visible",
            formatter: "tickCross",
            editor: true,
          },
        ],
      });

      // Forçar atualização da tabela principal
      mainTableRef.current.redraw();
    }
  };

  // Editor personalizado para filtro de duração
  const durationFilterEditor = (cell: any, onRendered: any, success: any, cancel: any) => {
    const container = document.createElement("span");

    const start = document.createElement("input");
    start.setAttribute("type", "number");
    start.setAttribute("placeholder", "Min");
    start.style.padding = "4px";
    start.style.width = "32%";

    const end = start.cloneNode() as HTMLInputElement;
    end.setAttribute("placeholder", "Max");

    const lista = document.createElement('select');
    lista.style.width = "32%";
    lista.style.padding = "2px";

    ['Minutos', 'Horas', 'Dias', 'Meses'].forEach(opt => {
      const option = document.createElement('option');
      option.value = opt.toLowerCase();
      option.text = opt;
      lista.appendChild(option);
    });

    const buildValues = () => {
      success({
        start: start.value,
        end: end.value,
        unit: lista.value
      });
    };

    [start, end, lista].forEach(el => {
      el.addEventListener("change", buildValues);
      el.addEventListener("blur", buildValues);
    });

    container.appendChild(start);
    container.appendChild(end);
    container.appendChild(lista);

    return container;
  };

  // Editor personalizado para filtro de data
  const dateEditor = (cell: any, onRendered: any, success: any, cancel: any) => {
    const container = document.createElement("span");

    // Criar inputs de data
    const date2 = document.createElement("input");
    date2.setAttribute("type", "date");
    date2.style.padding = "3px";
    date2.style.width = "50%";
    date2.style.fontSize = "12px";
    date2.style.boxSizing = "border-box";

    const date1 = date2.cloneNode() as HTMLInputElement;

    // Configurar datas iniciais
    const hoje = new Date();
    date2.value = hoje.toISOString().split('T')[0];

    const dataAnterior = new Date();
    dataAnterior.setFullYear(dataAnterior.getFullYear() - 1);
    date1.value = dataAnterior.toISOString().split('T')[0];

    const buildValues = () => {
      success({
        date1: date1.value,
        date2: date2.value,
      });
    };

    const keypress = (e: KeyboardEvent) => {
      if (e.key === "Enter") {
        buildValues();
      }
      if (e.key === "Escape") {
        cancel();
      }
    };

    // Adicionar event listeners
    [date1, date2].forEach(el => {
      el.addEventListener("change", buildValues);
      el.addEventListener("blur", buildValues);
      el.addEventListener("keydown", keypress);
    });

    container.appendChild(date1);
    container.appendChild(date2);

    return container;
  };

  // Função de filtro para datas
  const dateFilterFunction = (headerValue: any, rowValue: any) => {
    // Se não há filtro definido, mostra todos os registros
    if (!headerValue || (!headerValue.date1 && !headerValue.date2)) return true;

    // Se o valor da linha é vazio/nulo, não mostra
    if (!rowValue) return false;

    // Função para normalizar qualquer formato de data para Date
    const normalizeDate = (dateValue: string | Date) => {
      // Se já é um objeto Date, retorna diretamente
      if (dateValue instanceof Date) return dateValue;

      // Tenta parsear formato DD/MM/YYYY HH:mm:ss
      const dateTimeMatch = String(dateValue).match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/);
      if (dateTimeMatch) {
        const [_, day, month, year, hours, minutes, seconds] = dateTimeMatch;
        return new Date(
          parseInt(year),
          parseInt(month) - 1,
          parseInt(day),
          parseInt(hours),
          parseInt(minutes),
          parseInt(seconds)
        );
      }

      // Tenta parsear como ISO
      const date = new Date(dateValue);
      return isNaN(date.getTime()) ? null : date;
    };

    // Normaliza a data da linha
    const rowDate = normalizeDate(rowValue);
    if (!rowDate) return false;

    // Função auxiliar para criar data local a partir da string YYYY-MM-DD
    const createLocalDate = (dateStr: string, isEnd: boolean) => {
      if (!dateStr) return null;
      const [year, month, day] = dateStr.split('-').map(Number);
      // Mês em JS é 0-indexed (0-11)
      const date = new Date(year, month - 1, day);

      if (isEnd) {
        date.setHours(23, 59, 59, 999);
      } else {
        date.setHours(0, 0, 0, 0);
      }
      return date;
    };

    const startDate = headerValue.date1 ? createLocalDate(headerValue.date1, false) : null;
    const endDate = headerValue.date2 ? createLocalDate(headerValue.date2, true) : null;

    if (startDate && endDate) {
      return rowDate >= startDate && rowDate <= endDate;
    }

    if (startDate) return rowDate >= startDate;
    if (endDate) return rowDate <= endDate;

    return true;
  };

  // Aplica os filtros do header nos dados ANTES de carregar na tabela (evita renderizar tudo e depois refiltrar)
  const aplicarFiltrosHeaderNosDados = (dados: IAtivosModel[]): IAtivosModel[] => {
    try {
      console.log('🔍 aplicarFiltrosHeaderNosDados - INÍCIO');
      console.log('📊 Dados recebidos:', dados.length);

      if (!mainTableRef.current || !Array.isArray(dados) || dados.length === 0) {
        console.log('🔍 Retornando dados sem filtros (tabela não disponível ou dados vazios)');
        return dados;
      }

      const headerFilters: Array<{ field: string; value: any }> = (mainTableRef.current.getHeaderFilters && mainTableRef.current.getHeaderFilters()) || [];
      console.log('🔍 Filtros do header encontrados:', headerFilters.length);
      console.log('🔍 Filtros:', headerFilters);

      if (!headerFilters || headerFilters.length === 0) {
        console.log('🔍 Retornando dados sem filtros (nenhum filtro ativo)');
        return dados;
      }

      const isEmptyFilter = (v: any) => v === null || v === undefined || v === '' || (Array.isArray(v) && v.length === 0);

      const passaFiltro = (row: any, filtro: { field: string; value: any }): boolean => {
        const { field, value } = filtro;
        if (isEmptyFilter(value)) return true;

        // Helpers
        const equalsOrIncludes = (rowValue: any) => {
          if (Array.isArray(value)) return value.includes(rowValue);
          return rowValue === value;
        };

        switch (field) {
          case 'Organizacao':
          case 'IdBeacon':
          case 'AtivoSituacao':
          case 'StatusGateway':
          case 'Local':
          case 'PlaceType':
          case 'LocalDescricao': {
            return equalsOrIncludes(row[field]);
          }
          case 'Ativo':
          case 'Descricao':
          case 'Associacao': {
            const texto = String(value).toLowerCase();
            const alvo = String(row[field] ?? '').toLowerCase();
            return texto === '' ? true : alvo.includes(texto);
          }
          case 'UltimaVisualizacao': {
            // Usa a mesma função do headerFilter para consistência
            return dateFilterFunction(value, row?.UltimaVisualizacao);
          }
          case 'TempoDecorrido': {
            const minutesRaw = row?.TempoDecorrido;
            const minutes = typeof minutesRaw === 'number' ? minutesRaw : parseInt(minutesRaw, 10);
            if (isNaN(minutes)) return false;

            let compareValue = minutes;
            const unit = (value?.unit || '').toString().toLowerCase();
            if (unit === 'horas') compareValue = minutes / 60;
            else if (unit === 'dias') compareValue = minutes / (60 * 24);
            else if (unit === 'meses') compareValue = minutes / (60 * 24 * 30);

            const start = parseInt(value?.start, 10);
            const end = parseInt(value?.end, 10);

            if (!isNaN(start) && !isNaN(end)) return compareValue >= start && compareValue <= end;
            if (!isNaN(start)) return compareValue >= start;
            if (!isNaN(end)) return compareValue <= end;
            return true;
          }
          default:
            return true;
        }
      };

      const resultado = dados.filter((row) => headerFilters.every((f) => passaFiltro(row, f)));
      console.log('🔍 aplicarFiltrosHeaderNosDados - FIM');
      console.log('📊 Dados após filtros:', resultado.length);
      return resultado;
    } catch (e) {
      console.error('❌ Erro ao aplicar filtros do header nos dados:', e);
      return dados;
    }
  };

  const ajustarHorario = (dataStr: string | null | undefined): string => {
    console.log('🕐 Formatando horário para:', dataStr);
    if (!dataStr) return "-";

    try {
      // Verificar se a data já está no formato correto
      const data = new Date(dataStr);

      // Verificar se a data é válida
      if (isNaN(data.getTime())) {
        console.warn('⚠️ Data inválida:', dataStr);
        return "-";
      }

      const dia = data.getDate().toString().padStart(2, '0');
      const mes = (data.getMonth() + 1).toString().padStart(2, '0');
      const ano = data.getFullYear();
      const hora = data.getHours().toString().padStart(2, '0');
      const minuto = data.getMinutes().toString().padStart(2, '0');
      const segundo = data.getSeconds().toString().padStart(2, '0');

      const resultado = `${dia}/${mes}/${ano} ${hora}:${minuto}:${segundo}`;
      console.log('🕐 Horário formatado:', resultado);
      return resultado;
    } catch (error) {
      console.error('❌ Erro ao formatar horário:', error);
      return "-";
    }
  };

  // Cache para ícones por ativo (IdAtivo)
  const iconCacheRef = useRef<Map<number, L.DivIcon | null>>(new Map());
  // Controla o último ativo selecionado para evitar race conditions
  const lastSelectedAtivoIdRef = useRef<number | null>(null);
  // Controla cancelamento de requisições de ícone pendentes
  const iconFetchAbortRef = useRef<AbortController | null>(null);

  // Cria um L.DivIcon a partir de um SVG (string)
  const createDivIconFromSvg = (svgContent: string): L.DivIcon => {
    // Sanitizar e preparar o SVG
    let sanitizedSvg = (svgContent || '').trim();

    // Ajustar atributos do SVG para garantir tamanho e cor corretos
    if (sanitizedSvg.includes('<svg')) {
      sanitizedSvg = sanitizedSvg
        .replace(/width="[^"]*"/, 'width="100%"')
        .replace(/height="[^"]*"/, 'height="100%"')
        .replace(/fill="[^"]*"/, 'fill="currentColor"');
    }

    return L.divIcon({
      className: 'custom-svg-icon',
      html: `
        <div style="
          width: 28px; height: 28px; border-radius: 50%; background: #ffffff; border: 2px solid #3388ff;
          display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 6px rgba(0,0,0,0.4);
          line-height: 0; color: #3388ff;
        ">
          <div style="
            width: 20px; height: 20px; display: flex; align-items: center; justify-content: center;
            overflow: hidden; line-height: 0;
          ">
            ${sanitizedSvg}
          </div>
        </div>
      `,
      iconSize: [28, 28],
      iconAnchor: [14, 14]
    });
  };

  // Cria um L.DivIcon a partir de uma classe de ícone Semantic UI (ex: 'desktop', 'car')
  const createDivIconFromClass = (className: string): L.DivIcon => {
    const safeClass = (className || '').trim();
    return L.divIcon({
      className: 'custom-class-icon',
      html: `
        <div style="
          width: 28px; height: 28px; border-radius: 50%; background: #ffffff; border: 2px solid #3388ff;
          display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 6px rgba(0,0,0,0.4);
          color: #3388ff;
          line-height: 0;
        ">
          <i class="ui icon ${safeClass}" style="
            font-size:16px; width:18px; height:18px; display:flex; align-items:center; justify-content:center;
            line-height: 0; transform: translate(1px, 1px);
          "></i>
        </div>
      `,
      iconSize: [28, 28],
      iconAnchor: [14, 14]
    });
  };

  // Consulta de ícone personalizado por IdAtivo (IdPrism) e IdApp (REACT_APP_POWER_BI_APPLICATIONID)
  const fetchIconForAtivo = async (idAtivo?: number | null, signal?: AbortSignal): Promise<L.DivIcon | null> => {
    try {
      if (!idAtivo) return null;
      // Cache
      const cached = iconCacheRef.current.get(idAtivo);
      if (cached !== undefined) return cached;

      const idApp = parseInt(process.env.REACT_APP_POWER_BI_APPLICATIONID || '0', 10) || 0;
      const url = `${backendUrl}/api/PrismTags/by-idsprism`;

      const resp = await fetch(url, {
        method: 'POST',
        headers: {
          'accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth?.Token}`
        },
        body: JSON.stringify({ IdsPrism: [idAtivo], IdApp: idApp }),
        signal
      });

      if (!resp.ok) {
        iconCacheRef.current.set(idAtivo, null);
        return null;
      }

      const response = await resp.json();

      // Verificar se a requisição foi bem sucedida e se há dados
      if (!response.IsRequestSuccessful || !response.Data || !Array.isArray(response.Data) || response.Data.length === 0) {
        iconCacheRef.current.set(idAtivo, null);
        return null;
      }

      const first = response.Data[0];
      let value = first?.Value;

      // Tentar fazer o parse do Value que agora é uma string JSON
      if (typeof value === 'string') {
        try {
          value = JSON.parse(value);
        } catch (e) {
          console.error('Erro ao fazer parse do Value:', e);
          iconCacheRef.current.set(idAtivo, null);
          return null;
        }
      }

      const svg: string | undefined = value?.SVG;
      const klass: string | undefined = value?.Class;

      let icon: L.DivIcon | null = null;
      if (svg && svg.trim()) icon = createDivIconFromSvg(svg);
      else if (klass && klass.trim()) icon = createDivIconFromClass(klass);

      iconCacheRef.current.set(idAtivo, icon);
      return icon;
    } catch (e) {
      return null;
    }
  };

  // Função para validar e formatar data para as APIs
  const formatarDataParaAPI = (dataStr: string | null | undefined): string => {
    console.log('🔧 Formatando data para API:', dataStr);

    if (!dataStr) {
      // Se não há data, usar data atual
      const hoje = new Date();
      const resultado = hoje.toISOString().split('T')[0];
      console.log('🔧 Usando data atual:', resultado);
      return resultado;
    }

    try {
      // Se a data já está no formato DD/MM/YYYY HH:mm:ss, converter para YYYY-MM-DD
      if (dataStr.includes('/')) {
        const partes = dataStr.split(' ')[0].split('/');
        if (partes.length === 3) {
          const dia = partes[0].padStart(2, '0');
          const mes = partes[1].padStart(2, '0');
          const ano = partes[2];
          const resultado = `${ano}-${mes}-${dia}`;
          console.log('🔧 Data convertida de DD/MM/YYYY:', resultado);
          return resultado;
        }
      }

      // Tentar criar uma data válida
      const data = new Date(dataStr);

      // Verificar se a data é válida
      if (isNaN(data.getTime())) {
        console.warn('⚠️ Data inválida para API:', dataStr);
        // Usar data atual como fallback
        const hoje = new Date();
        const resultado = hoje.toISOString().split('T')[0];
        console.log('🔧 Usando data atual como fallback:', resultado);
        return resultado;
      }

      // Retornar apenas a parte da data (YYYY-MM-DD)
      const resultado = data.toISOString().split('T')[0];
      console.log('🔧 Data formatada com sucesso:', resultado);
      return resultado;
    } catch (error) {
      console.error('❌ Erro ao formatar data para API:', error);
      // Usar data atual como fallback
      const hoje = new Date();
      const resultado = hoje.toISOString().split('T')[0];
      console.log('🔧 Usando data atual como fallback após erro:', resultado);
      return resultado;
    }
  };

  // Função para formatar data e hora completa para API
  // Função para buscar dados de tracking do ativo (similar ao MapLocais.tsx)
  const fetchTrackingDataForAtivo = async (ativoData: IAtivosModel): Promise<{ latitude: number; longitude: number; metodo?: string; gateway?: string; lastSeen?: string } | null> => {
    try {
      console.log('📡 Buscando dados de tracking para ativo:', ativoData.Ativo);

      // Buscar o nome da corporação selecionada
      const corporacaoNome = selectedCorporation
        ? availableCorporations.find(corp => corp.id === selectedCorporation)?.name
        : ativoData.Corporacao;

      const orgsToSend = selectedOrganizations.length > 0
        ? selectedOrganizations
        : (ativoData.Organizacao ? [ativoData.Organizacao] : []);

      // Formatar data/hora da última visualização ou usar data atual
      let dtfinal = '';
      if (ativoData.UltimaVisualizacao) {
        dtfinal = formatarDataHoraParaAPI(ativoData.UltimaVisualizacao);
      } else {
        const hoje = new Date();
        dtfinal = hoje.toISOString().replace('T', ' ').split('.')[0];
      }

      // Payload para buscar dados
      const payload = {
        Corporacao: corporacaoNome,
        Organizacao: orgsToSend,
        Ativos: [ativoData.Ativo],
        Interferencia: 3,
        dtfinal: dtfinal
      };

      console.log('📡 Payload para busca de tracking:', payload);

      // Verificar LastlatLongOrigin para determinar qual API chamar
      const lastlatLongOrigin = ativoData.LastlatLongOrigin || ativoData.LatLongOrigin;
      console.log('🔍 LastlatLongOrigin do ativo:', lastlatLongOrigin);

      // Se LastlatLongOrigin for "B", chamar apenas BeaconNred
      if (lastlatLongOrigin === 'B' || lastlatLongOrigin === 'b') {
        console.log('📍 Chamando BeaconNred (LastlatLongOrigin = B)');
        try {
          const beaconResponse = await fetch(`${backendUrl}/api/BeaconNred`, {
            method: 'POST',
            headers: {
              'accept': 'application/json',
              'Content-Type': 'application/json-patch+json',
              'Authorization': `Bearer ${auth?.Token}`
            },
            body: JSON.stringify(payload)
          });

          if (beaconResponse.ok) {
            let beaconData = await beaconResponse.json();
            if (typeof beaconData === 'string') {
              try {
                beaconData = JSON.parse(beaconData);
              } catch (e) {
                console.warn('Erro ao parsear resposta BeaconNred:', e);
              }
            }

            // Tratar array aninhado (Ex: [[dados], {metadata}])
            let dataToProcess = beaconData;
            if (Array.isArray(beaconData) && beaconData.length > 0 && Array.isArray(beaconData[0])) {
              console.log("📦 [fetchTrackingDataForAtivo] Detectada estrutura de array aninhado. Extraindo índice 0.");
              dataToProcess = beaconData[0];
            }

            if (Array.isArray(dataToProcess) && dataToProcess.length > 0) {
              // Encontrar o registro do ativo específico
              const ativoBeacon = dataToProcess.find((item: any) => item.Ativo === ativoData.Ativo);
              if (ativoBeacon && ativoBeacon.Latitude && ativoBeacon.Longitude) {
                const lat = typeof ativoBeacon.Latitude === 'string' ? parseFloat(ativoBeacon.Latitude) : ativoBeacon.Latitude;
                const lng = typeof ativoBeacon.Longitude === 'string' ? parseFloat(ativoBeacon.Longitude) : ativoBeacon.Longitude;

                if (!isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0) {
                  console.log('✅ Dados encontrados no BeaconNred:', { lat, lng });
                  setTrackingDataAtivo(ativoBeacon);
                  return {
                    latitude: lat,
                    longitude: lng,
                    metodo: 'gps',
                    gateway: ativoBeacon.Gateway || null,
                    lastSeen: ativoBeacon.LastSeen || null
                  };
                }
              }
            }
          }
        } catch (error) {
          console.warn('⚠️ Erro ao buscar BeaconNred:', error);
        }
      }
      // Se LastlatLongOrigin for "G", chamar apenas GatewayNred
      else if (lastlatLongOrigin === 'G' || lastlatLongOrigin === 'g') {
        console.log('📍 Chamando GatewayNred (LastlatLongOrigin = G)');
        try {
          const gatewayResponse = await fetch(`${backendUrl}/api/GatewayNred`, {
            method: 'POST',
            headers: {
              'accept': 'application/json',
              'Content-Type': 'application/json-patch+json',
              'Authorization': `Bearer ${auth?.Token}`
            },
            body: JSON.stringify(payload)
          });

          if (gatewayResponse.ok) {
            let gatewayData = await gatewayResponse.json();
            if (typeof gatewayData === 'string') {
              try {
                gatewayData = JSON.parse(gatewayData);
              } catch (e) {
                console.warn('Erro ao parsear resposta GatewayNred:', e);
              }
            }

            // Tratar array aninhado (Ex: [[dados], {metadata}])
            let dataToProcess = gatewayData;
            if (Array.isArray(gatewayData) && gatewayData.length > 0 && Array.isArray(gatewayData[0])) {
              console.log("📦 [fetchTrackingDataForAtivo-GatewayNred] Detectada estrutura de array aninhado. Extraindo índice 0.");
              dataToProcess = gatewayData[0];
            }

            if (Array.isArray(dataToProcess) && dataToProcess.length > 0) {
              // Encontrar o registro do ativo específico
              const ativoGateway = dataToProcess.find((item: any) => item.Ativo === ativoData.Ativo);
              if (ativoGateway) {
                // Para métodos estimado ou centroide, usar coordenadas aleatórias se disponíveis
                let lat, lng;
                const metodo = ativoGateway.Metodo ? ativoGateway.Metodo.toLowerCase() : 'trilateracao';

                if (metodo === 'estimado' || metodo === 'centroide') {
                  lat = ativoGateway.LatitudeAleatoria || ativoGateway.Latitude;
                  lng = ativoGateway.LongitudeAleatoria || ativoGateway.Longitude;
                } else {
                  lat = ativoGateway.Latitude;
                  lng = ativoGateway.Longitude;
                }

                if (lat && lng) {
                  const latitude = typeof lat === 'string' ? parseFloat(lat) : lat;
                  const longitude = typeof lng === 'string' ? parseFloat(lng) : lng;

                  if (!isNaN(latitude) && !isNaN(longitude) && latitude !== 0 && longitude !== 0) {
                    console.log('✅ Dados encontrados no GatewayNred:', { latitude, longitude, metodo });
                    setTrackingDataAtivo(ativoGateway);
                    return {
                      latitude,
                      longitude,
                      metodo,
                      gateway: ativoGateway.Gateway || null,
                      lastSeen: ativoGateway.LastSeen || null
                    };
                  }
                }
              }
            }
          }
        } catch (error) {
          console.warn('⚠️ Erro ao buscar GatewayNred:', error);
        }
      }
      // Se não houver LastlatLongOrigin ou for outro valor, tentar ambas APIs (comportamento anterior)
      else {
        console.log('⚠️ LastlatLongOrigin não definido ou valor desconhecido, tentando ambas APIs');

        // Tentar primeiro BeaconNred (GPS)
        try {
          const beaconResponse = await fetch(`${backendUrl}/api/BeaconNred`, {
            method: 'POST',
            headers: {
              'accept': 'application/json',
              'Content-Type': 'application/json-patch+json',
              'Authorization': `Bearer ${auth?.Token}`
            },
            body: JSON.stringify(payload)
          });

          if (beaconResponse.ok) {
            let beaconData = await beaconResponse.json();
            if (typeof beaconData === 'string') {
              try {
                beaconData = JSON.parse(beaconData);
              } catch (e) {
                console.warn('Erro ao parsear resposta BeaconNred:', e);
              }
            }

            if (Array.isArray(beaconData) && beaconData.length > 0) {
              // Encontrar o registro do ativo específico
              const ativoBeacon = beaconData.find((item: any) => item.Ativo === ativoData.Ativo);
              if (ativoBeacon && ativoBeacon.Latitude && ativoBeacon.Longitude) {
                const lat = typeof ativoBeacon.Latitude === 'string' ? parseFloat(ativoBeacon.Latitude) : ativoBeacon.Latitude;
                const lng = typeof ativoBeacon.Longitude === 'string' ? parseFloat(ativoBeacon.Longitude) : ativoBeacon.Longitude;

                if (!isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0) {
                  console.log('✅ Dados encontrados no BeaconNred:', { lat, lng });
                  setTrackingDataAtivo(ativoBeacon);
                  return {
                    latitude: lat,
                    longitude: lng,
                    metodo: ativoBeacon.lat_long_origin === 'B' ? 'gps' : 'gateway',
                    gateway: ativoBeacon.Gateway || null,
                    lastSeen: ativoBeacon.LastSeen || null
                  };
                }
              }
            }
          }
        } catch (error) {
          console.warn('⚠️ Erro ao buscar BeaconNred:', error);
        }

        // Se não encontrou no BeaconNred, tentar GatewayNred
        try {
          const gatewayResponse = await fetch(`${backendUrl}/api/GatewayNred`, {
            method: 'POST',
            headers: {
              'accept': 'application/json',
              'Content-Type': 'application/json-patch+json',
              'Authorization': `Bearer ${auth?.Token}`
            },
            body: JSON.stringify(payload)
          });

          if (gatewayResponse.ok) {
            let gatewayData = await gatewayResponse.json();
            if (typeof gatewayData === 'string') {
              try {
                gatewayData = JSON.parse(gatewayData);
              } catch (e) {
                console.warn('Erro ao parsear resposta GatewayNred:', e);
              }
            }

            // Tratar array aninhado (Ex: [[dados], {metadata}])
            let dataToProcess = gatewayData;
            if (Array.isArray(gatewayData) && gatewayData.length > 0 && Array.isArray(gatewayData[0])) {
              console.log("📦 [fetchTrackingDataForAtivo-GatewayNred] Detectada estrutura de array aninhado. Extraindo índice 0.");
              dataToProcess = gatewayData[0];
            }

            if (Array.isArray(dataToProcess) && dataToProcess.length > 0) {
              // Encontrar o registro do ativo específico
              const ativoGateway = dataToProcess.find((item: any) => item.Ativo === ativoData.Ativo);
              if (ativoGateway) {
                // Para métodos estimado ou centroide, usar coordenadas aleatórias se disponíveis
                let lat, lng;
                const metodo = ativoGateway.Metodo ? ativoGateway.Metodo.toLowerCase() : 'trilateracao';

                if (metodo === 'estimado' || metodo === 'centroide') {
                  lat = ativoGateway.LatitudeAleatoria || ativoGateway.Latitude;
                  lng = ativoGateway.LongitudeAleatoria || ativoGateway.Longitude;
                } else {
                  lat = ativoGateway.Latitude;
                  lng = ativoGateway.Longitude;
                }

                if (lat && lng) {
                  const latitude = typeof lat === 'string' ? parseFloat(lat) : lat;
                  const longitude = typeof lng === 'string' ? parseFloat(lng) : lng;

                  if (!isNaN(latitude) && !isNaN(longitude) && latitude !== 0 && longitude !== 0) {
                    console.log('✅ Dados encontrados no GatewayNred:', { latitude, longitude, metodo });
                    setTrackingDataAtivo(ativoGateway);
                    return {
                      latitude,
                      longitude,
                      metodo,
                      gateway: ativoGateway.Gateway || null,
                      lastSeen: ativoGateway.LastSeen || null
                    };
                  }
                }
              }
            }
          }
        } catch (error) {
          console.warn('⚠️ Erro ao buscar GatewayNred:', error);
        }
      }

      // Se não encontrou em nenhuma API, retornar null para usar dados do PowerBI como fallback
      console.log('⚠️ Nenhum dado de tracking encontrado, usando dados do PowerBI');
      return null;

    } catch (error) {
      console.error('❌ Erro ao buscar dados de tracking:', error);
      return null;
    }
  };

  const formatarDataHoraParaAPI = (dataStr: string | null | undefined): string => {
    console.log('🔧 Formatando data e hora para API:', dataStr);

    if (!dataStr) {
      // Se não há data, usar data atual
      const hoje = new Date();
      const resultado = hoje.toISOString().replace('T', ' ').split('.')[0];
      console.log('🔧 Usando data atual completa:', resultado);
      return resultado;
    }

    try {
      // Se a data já está no formato DD/MM/YYYY HH:mm:ss, converter para YYYY-MM-DD HH:mm:ss
      if (dataStr.includes('/')) {
        const partes = dataStr.split(' ');
        if (partes.length >= 2) {
          const dataPartes = partes[0].split('/');
          const horaPartes = partes[1];
          if (dataPartes.length === 3) {
            const dia = dataPartes[0].padStart(2, '0');
            const mes = dataPartes[1].padStart(2, '0');
            const ano = dataPartes[2];
            const resultado = `${ano}-${mes}-${dia} ${horaPartes}`;
            console.log('🔧 Data e hora convertida de DD/MM/YYYY HH:mm:ss:', resultado);
            return resultado;
          }
        }
        // Se só tem data sem hora, adicionar hora padrão
        const dataPartes = dataStr.split('/');
        if (dataPartes.length === 3) {
          const dia = dataPartes[0].padStart(2, '0');
          const mes = dataPartes[1].padStart(2, '0');
          const ano = dataPartes[2];
          const resultado = `${ano}-${mes}-${dia} 00:00:00`;
          console.log('🔧 Data convertida sem hora, adicionando 00:00:00:', resultado);
          return resultado;
        }
      }

      // Tentar criar uma data válida
      const data = new Date(dataStr);

      // Verificar se a data é válida
      if (isNaN(data.getTime())) {
        console.warn('⚠️ Data inválida para API:', dataStr);
        // Usar data atual como fallback
        const hoje = new Date();
        const resultado = hoje.toISOString().replace('T', ' ').split('.')[0];
        console.log('🔧 Usando data atual como fallback:', resultado);
        return resultado;
      }

      // Retornar data e hora completa (YYYY-MM-DD HH:mm:ss)
      const resultado = data.toISOString().replace('T', ' ').split('.')[0];
      console.log('🔧 Data e hora formatada com sucesso:', resultado);
      return resultado;
    } catch (error) {
      console.error('❌ Erro ao formatar data e hora para API:', error);
      // Usar data atual como fallback
      const hoje = new Date();
      const resultado = hoje.toISOString().replace('T', ' ').split('.')[0];
      console.log('🔧 Usando data atual como fallback após erro:', resultado);
      return resultado;
    }
  };

  // Adicione esta função para adicionar o marcador quando o ativo é selecionado
  const addMarkerToMap = async (data: IAtivosModel) => {
    console.log('🗺️ Adicionando marcador para:', data.Ativo);

    // Buscar dados de tracking primeiro (similar ao MapLocais.tsx)
    // Usar LastLatitude e LastLongitude se disponíveis, senão usar Latitude e Longitude
    let latitude = data.LastLatitude != null ? data.LastLatitude : data.Latitude;
    let longitude = data.LastLongitude != null ? data.LastLongitude : data.Longitude;
    let metodo: string | undefined = undefined;

    console.log('📡 Buscando dados de tracking para obter coordenadas atualizadas...');
    const trackingData = await fetchTrackingDataForAtivo(data);

    if (trackingData && trackingData.latitude && trackingData.longitude) {
      latitude = trackingData.latitude;
      longitude = trackingData.longitude;
      metodo = trackingData.metodo;
      // Os dados já foram salvos pelo fetchTrackingDataForAtivo via setTrackingDataAtivo
      console.log('✅ Usando coordenadas das APIs de tracking:', { latitude, longitude, metodo });
    } else {
      console.log('⚠️ Usando coordenadas do PowerBI como fallback:', { latitude, longitude });
    }

    console.log('🗺️ Coordenadas finais para plotar:', { latitude, longitude });

    // Função auxiliar para aguardar mapa e markersGroup estarem prontos
    const waitForMapAndMarkersGroup = async (maxAttempts = 10) => {
      for (let attempt = 1; attempt <= maxAttempts; attempt++) {
        console.log(`🔄 Tentativa ${attempt} de ${maxAttempts} - Verificando mapa e markersGroup...`);

        if (mapRef.current && mapRef.current.getContainer()) {
          // Inicializar markersGroup se não existir
          if (!markersGroup.current) {
            console.log('🗺️ Inicializando markersGroup...');
            markersGroup.current = L.layerGroup().addTo(mapRef.current);
            console.log('🗺️ markersGroup inicializado');
          }
          return true;
        }

        if (attempt < maxAttempts) {
          console.log(`⏳ Aguardando 200ms antes da próxima tentativa...`);
          await new Promise(resolve => setTimeout(resolve, 200));
        }
      }
      return false;
    };

    // Aguardar até que mapa e markersGroup estejam prontos
    const isReady = await waitForMapAndMarkersGroup();
    if (!isReady) {
      console.error('❌ Timeout: Mapa não ficou pronto após múltiplas tentativas');
      return;
    }

    if (latitude && longitude && !isNaN(latitude) && !isNaN(longitude) && latitude !== 0 && longitude !== 0) {
      // Limpa marcadores existentes
      if (markersGroup.current) {
        markersGroup.current.clearLayers();
        currentAtivoMarkerRef.current = null; // Limpar referência ao marcador anterior
      }

      // Registrar último ativo selecionado
      lastSelectedAtivoIdRef.current = data.IdAtivo;

      // Ícone fallback imediato (não bloquear a UI)
      const fallbackIcon = L.divIcon({
        className: 'custom-div-icon',
        html: `<div style="
          background-color: #3388ff !important; 
          width: 20px !important; 
          height: 20px !important; 
          border-radius: 50% !important; 
          border: 3px solid white !important; 
          box-shadow: 0 2px 6px rgba(0,0,0,0.4) !important;
          position: relative !important;
          z-index: 1000 !important;
          display: block !important;
          visibility: visible !important;
          opacity: 1 !important;
        "></div>`,
        iconSize: [26, 26],
        iconAnchor: [13, 13]
      });

      // Criar marcador de imediato com fallback
      const marker = L.marker([latitude, longitude], {
        icon: fallbackIcon,
        zIndexOffset: 2000
      });

      // Obter dados da API se disponíveis (trackingData contém Gateway e LastSeen da API)
      const gatewayFromAPI = trackingData?.gateway || null;
      const lastSeenFromAPI = trackingData?.lastSeen || null;

      // Usar dados da API se disponíveis, senão usar dados do PowerBI
      const gatewayDisplay = gatewayFromAPI || data.Gateway || "-";
      const ultimaVisualizacaoDisplay = lastSeenFromAPI ? ajustarHorario(lastSeenFromAPI) : ajustarHorario(data.UltimaVisualizacao);

      // Adiciona popup
      const popup = L.popup().setContent(`
          <div style="text-align: left;">
          <b>Gateway:</b> ${gatewayDisplay}<br>
          <b>Última Visualização:</b> ${ultimaVisualizacaoDisplay}<br>
          <b>Ativo:</b> ${data.Ativo}<br>
          <b>Local:</b> ${data.Local || "-"}<br>
          <b>Latitude:</b> ${latitude.toFixed(6)}<br>
          <b>Longitude:</b> ${longitude.toFixed(6)}<br>
          ${metodo ? `<b>Método:</b> ${metodo.toUpperCase()}<br>` : ''}
          <b>Status:</b> ${data.Status || "-"}<br>
          <br><i>Clique no marcador para ver círculos de cobertura</i>
        `);

      marker.bindPopup(popup).openPopup();

      // Buscar ícone personalizado em paralelo com cancelamento da busca anterior
      try {
        if (iconFetchAbortRef.current) {
          iconFetchAbortRef.current.abort();
        }
        const controller = new AbortController();
        iconFetchAbortRef.current = controller;

        fetchIconForAtivo(data.IdAtivo, controller.signal)
          .then((customIcon) => {
            if (!customIcon) return;
            // Ignorar se já mudou de seleção ou se a requisição foi abortada
            if (lastSelectedAtivoIdRef.current !== data.IdAtivo) return;
            marker.setIcon(customIcon);
          })
          .catch(() => { /* silencioso */ });
      } catch { /* silencioso */ }

      // Adicionar evento de clique no marcador para chamar APIs e desenhar círculos
      marker.on('click', async () => {
        console.log('🖱️ Clique no marcador do ativo:', data.Ativo);
        console.log('🔄 Chamando APIs e desenhando círculos...');

        // Verificar se o mapa está pronto antes de chamar plotGatewayAndBeaconData
        if (!mapRef.current || !mapRef.current.getContainer()) {
          console.warn('🗺️ ⚠️ Mapa não está pronto, aguardando...');
          await new Promise(resolve => setTimeout(resolve, 500));
        }

        plotGatewayAndBeaconData(data);
      });

      if (markersGroup.current) {
        markersGroup.current.addLayer(marker);
        currentAtivoMarkerRef.current = marker; // Armazenar referência ao marcador atual
        console.log('✅ Marcador do ativo adicionado ao markersGroup');
        console.log('🗺️ Total de layers no markersGroup:', markersGroup.current.getLayers().length);
      } else {
        console.error('❌ markersGroup.current não existe!');
      }

      if (mapRef.current) {
        mapRef.current.setView([latitude, longitude], 15);
        console.log('🗺️ Mapa centralizado na posição do ativo');
      } else {
        console.error('❌ mapRef.current não existe!');
      }

      console.log('✅ Marcador adicionado com sucesso');
    } else {
      console.warn('⚠️ Não foi possível adicionar marcador:', {
        latitude: latitude,
        longitude: longitude,
        mapRef: !!mapRef.current,
        markersGroup: !!markersGroup.current
      });
    }
  };

  // Adicione esta função para lidar com o clique na linha
  const handleRowClick = async (e: Event, row: any) => {
    const data = row.getData();
    console.log('🖱️ Dados da linha clicada:', data);

    if (mainTableRef.current) {
      const selectedRows = mainTableRef.current.getSelectedRows();
      selectedRows.forEach((selectedRow: any) => {
        selectedRow.deselect();
      });
    }

    row.select();

    setSelectedAtivo(data);
    setDetailsVisible(true);
    // Limpar dados de tracking anteriores para buscar novos dados
    setTrackingDataAtivo(null);
    obterChamadosAtivo(data.Ativo);
    console.log('🔍 Dados do ativo selecionado:', {
      IdAtivo: data.IdAtivo,
      IdOrganizacao: data.IdOrganizacao,
      IdOrganizacao_tipo: typeof data.IdOrganizacao,
      Organizacao: data.Organizacao
    });
    obterMovimentacoesAtivo(data.IdAtivo, data.IdOrganizacao, data.Corporacao, data.Organizacao, data.Ativo);

    // Aguardar um pequeno delay para garantir que o mapa esteja renderizado
    await new Promise(resolve => setTimeout(resolve, 100));

    // Apenas renderizar o ativo no mapa, sem chamar APIs
    console.log('🗺️ Renderizando ativo no mapa:', data.Ativo);
    await addMarkerToMap(data);
  };

  const createInputFilterEditor = (field: keyof IAtivosModel) => (cell: any, onRendered: any, success: any, cancel: any) => {
    const container = document.createElement("div");
    container.style.position = "relative"; // Garante que a lista seja posicionada corretamente

    // Input para digitar o filtro
    const input = document.createElement("input");
    input.setAttribute("type", "text");
    input.setAttribute("placeholder", "Buscar...");
    input.classList.add("filter-input"); // Adiciona a classe do input

    // Lista de sugestões
    const suggestionList = document.createElement("div");
    suggestionList.classList.add("suggestion-list"); // Adiciona a classe da lista
    suggestionList.style.position = "absolute";
    suggestionList.style.top = "100%";
    suggestionList.style.left = "0";
    suggestionList.style.right = "0";
    suggestionList.style.zIndex = "1000"; // Aumente o z-index
    suggestionList.style.maxHeight = "200px";
    suggestionList.style.overflowY = "auto";
    suggestionList.style.display = "none";

    // Adiciona a lista de sugestões ao body
    document.body.appendChild(suggestionList);

    // Função para atualizar a lista de sugestões
    const updateSuggestions = (filterText: string) => {
      const tableData = mainTableRef.current.getData(); // Acessa os dados da tabela
      const uniqueValues = Array.from(new Set(tableData.map((item: any) => item[field])));
      const filteredValues = uniqueValues.filter((value: any) =>
        value?.toString().toLowerCase().includes(filterText.toLowerCase())
      );

      suggestionList.innerHTML = ""; // Limpa a lista atual
      filteredValues.forEach((value) => {
        const suggestionItem = document.createElement("div");
        suggestionItem.textContent = String(value);
        suggestionItem.classList.add("suggestion-item"); // Adiciona a classe do item
        suggestionItem.addEventListener("click", () => {
          input.value = String(value); // Preenche o input com o valor selecionado
          suggestionList.style.display = "none"; // Oculta a lista
          success(value); // Aplica o filtro
        });
        suggestionList.appendChild(suggestionItem);
      });

      if (filteredValues.length > 0) {
        suggestionList.style.display = "block"; // Mostra a lista
      } else {
        suggestionList.style.display = "none"; // Oculta a lista se não houver sugestões
      }
    };

    // Evento de digitação no input
    input.addEventListener("input", (e) => {
      const filterText = (e.target as HTMLInputElement).value;
      updateSuggestions(filterText);

      // Atualiza a posição da lista de sugestões
      const rect = input.getBoundingClientRect();
      suggestionList.style.top = `${rect.bottom + window.scrollY}px`;
      suggestionList.style.left = `${rect.left + window.scrollX}px`;
      suggestionList.style.width = `${rect.width}px`;
    });

    // Evento de foco no input
    input.addEventListener("focus", () => {
      updateSuggestions(input.value);

      // Atualiza a posição da lista de sugestões
      const rect = input.getBoundingClientRect();
      suggestionList.style.top = `${rect.bottom + window.scrollY}px`;
      suggestionList.style.left = `${rect.left + window.scrollX}px`;
      suggestionList.style.width = `${rect.width}px`;
    });

    // Evento de clique fora do input (para ocultar a lista)
    document.addEventListener("click", (e) => {
      if (!container.contains(e.target as Node)) {
        suggestionList.style.display = "none";
      }
    });

    container.appendChild(input);

    return container;
  };
  const createInputFilterFunction = (field: string) => (headerValue: string, rowValue: string) => {
    if (!headerValue) return true; // Se não houver filtro, mostra todas as linhas
    return rowValue?.toString().toLowerCase().includes(headerValue.toLowerCase());
  };

  const getBaseColumns = (): ColumnDefinition[] => [{
    title: "Organização",
    field: "Organizacao",
    headerFilter: "list",
    headerFilterParams: {
      values: true,
      multiselect: true,
      clearable: true,
      sort: "asc"
    },
    headerFilterFunc: (headerValue: any, rowValue: any) => {
      if (!headerValue || headerValue.length === 0) return true;
      if (Array.isArray(headerValue)) {
        return headerValue.includes(rowValue);
      }
      return headerValue === rowValue;
    },
    headerFilterPlaceholder: "Selecione...",
    width: 200,
    sorter: "string"
  },
  {
    title: "Ativo",
    field: "Ativo",
    sorter: "string",
    headerFilter: "input",
    headerFilterPlaceholder: "Digite para filtrar...",
    headerFilterLiveFilter: false,
    formatter: (cell) => {
      const data = cell.getRow().getData();
      return `
                  <a href='/detalhes-do-ativo?ativo=${data.Ativo}' target='_blank' style='margin-right: 10px;'>
                    <i class='ui icon external alternate' style='cursor: pointer;'></i>
                  </a>
                  ${cell.getValue()}`;
    },
  },
  {
    title: "Beacon",
    field: "IdBeacon",
    sorter: "string",
    headerFilter: "list",
    headerFilterParams: {
      values: true,
      multiselect: true,
      clearable: true,
      sort: "asc"
    },
    headerFilterFunc: (headerValue: any, rowValue: any) => {
      if (!headerValue || headerValue.length === 0) return true;
      if (Array.isArray(headerValue)) {
        return headerValue.includes(rowValue);
      }
      return headerValue === rowValue;
    },
    headerFilterPlaceholder: "Selecione...",
  },
  {
    title: "Ativo Situação",
    field: "AtivoSituacao",
    sorter: "string",
    headerFilter: "list",
    headerFilterParams: {
      values: true,
      multiselect: true,
      clearable: true,
      sort: "asc"
    },
    headerFilterFunc: (headerValue: any, rowValue: any) => {
      if (!headerValue || headerValue.length === 0) return true;
      if (Array.isArray(headerValue)) {
        return headerValue.includes(rowValue);
      }
      return headerValue === rowValue;
    },
    headerFilterPlaceholder: "Selecione...",
    formatter: (cell: any) =>
      cell.getValue() === "Habilitado"
        ? "<i class='ui green toggle on icon'></i> Habilitado"
        : "<i class='ui red toggle off icon'></i> Desabilitado",
    hozAlign: "center",
  },
  {
    title: "Associação",
    field: "Associacao",
    sorter: "string",
    headerFilter: "input",
    headerFilterPlaceholder: "Digite para filtrar...",
    headerFilterLiveFilter: false,
    formatter: (cell: any) => {
      const value = cell.getValue();
      return value ? value : "-";
    },
    hozAlign: "center",
  },
  {
    title: "Status",
    field: "StatusGateway",
    sorter: "string",
    headerFilter: "list",
    headerFilterParams: {
      values: true,
      multiselect: true,
      clearable: true,
      sort: "asc"
    },
    headerFilterFunc: (headerValue: any, rowValue: any) => {
      if (!headerValue || headerValue.length === 0) return true;
      if (Array.isArray(headerValue)) {
        return headerValue.includes(rowValue);
      }
      return headerValue === rowValue;
    },
    headerFilterPlaceholder: "Selecione...",
    formatter: (cell: any) =>
      cell.getValue() === "Sem leitura"
        ? "<i class='ui red warning sign icon'></i> Sem leitura"
        : cell.getValue(),
    hozAlign: "center",
  },
  {
    title: "Última Visualização",
    field: "UltimaVisualizacao",
    headerFilter: dateEditor,
    headerFilterFunc: dateFilterFunction,
    sorter: (a: string, b: string) => {
      const toTimestamp = (dateTimeStr: string) => {
        const match = dateTimeStr.match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/);
        if (match) {
          const [_, day, month, year, hours, mins, secs] = match;
          return new Date(
            parseInt(year),
            parseInt(month) - 1,
            parseInt(day),
            parseInt(hours),
            parseInt(mins),
            parseInt(secs)
          ).getTime();
        }

        // Tenta formato ISO
        const isoDate = new Date(dateTimeStr);
        return isNaN(isoDate.getTime()) ? 0 : isoDate.getTime();
      };

      const timeA = a ? toTimestamp(a) : 0;
      const timeB = b ? toTimestamp(b) : 0;
      return timeA - timeB;
    },
    formatter: (cell: any) => {
      const value = cell.getValue();
      if (!value) return " - ";

      if (typeof value === 'string' && value.match(/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/)) {
        // Ajusta o formato DD/MM/YYYY HH:mm:ss para subtrair 3 horas
        const match = value.match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/);
        if (match) {
          const [_, day, month, year, hours, mins, secs] = match;
          const date = moment(
            new Date(
              parseInt(year),
              parseInt(month) - 1,
              parseInt(day),
              parseInt(hours),
              parseInt(mins),
              parseInt(secs)
            )
          );
          return date.format("DD/MM/YYYY HH:mm:ss");
        }
        return value;
      }

      const date = moment(value);
      return date.isValid() ? date.format("DD/MM/YYYY HH:mm:ss") : "N/A";
    },
  },
  {
    title: "Tempo decorrido",
    field: "TempoDecorrido",
    headerFilter: durationFilterEditor,
    headerFilterFunc: (headerValue: any, rowValue: any) => {
      if (!headerValue || !headerValue.start) return true;

      const minutes = parseInt(rowValue);
      if (isNaN(minutes)) return false;

      let compareValue = minutes;
      if (headerValue.unit === "horas") {
        compareValue = minutes / 60;
      } else if (headerValue.unit === "dias") {
        compareValue = minutes / (60 * 24);
      }
      else if (headerValue.unit === "meses") {
        compareValue = minutes / (60 * 24 * 30);
      }

      const start = parseInt(headerValue.start);
      const end = parseInt(headerValue.end);

      if (start && end) {
        return compareValue >= start && compareValue <= end;
      } else if (start) {
        return compareValue >= start;
      } else if (end) {
        return compareValue <= end;
      }
      return true;
    },
    formatter: (cell) => {
      const totalMinutes = cell.getValue();
      const months = Math.floor(totalMinutes / (60 * 24 * 30));
      const days = Math.floor(
        (totalMinutes % (60 * 24 * 30)) / (60 * 24)
      );
      const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
      const minutes = totalMinutes % 60;

      const M = months ? `${months} M, ` : '';
      const D = days ? `${days} d, ` : '';
      const H = hours ? `${hours} h e ` : '';
      const I = `${minutes} min`;

      return `${M}${D}${H}${I}`;
    },
  },
  {
    title: "Alertar em", // ALTERADO
    field: "TempoDeCarencia",
    formatter: (cell) => {
      const totalMinutes = cell.getValue();
      const months = Math.floor(totalMinutes / (60 * 24 * 30));
      const days = Math.floor(
        (totalMinutes % (60 * 24 * 30)) / (60 * 24)
      );
      const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
      const minutes = totalMinutes % 60;

      const M = months ? `${months} M, ` : '';
      const D = days ? `${days} d, ` : '';
      const H = hours ? `${hours} h e ` : '';
      const I = `${minutes} min`;

      return `${M}${D}${H}${I}`;
    },
  },
  {
    title: "Tempo decorrido do Alerta",
    field: "MinutosDeAlerta",
    formatter: (cell) => {
      const totalMinutes = cell.getValue();
      const months = Math.floor(totalMinutes / (60 * 24 * 30));
      const days = Math.floor(
        (totalMinutes % (60 * 24 * 30)) / (60 * 24)
      );
      const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
      const minutes = totalMinutes % 60;

      const M = months ? `${months} M, ` : '';
      const D = days ? `${days} d, ` : '';
      const H = hours ? `${hours} h e ` : '';
      const I = `${minutes} min`;

      return `${M}${D}${H}${I}`;
    },
  },

  {
    title: "Local",
    field: "Local",
    sorter: "string",
    headerFilter: "list",
    headerFilterParams: {
      values: true,
      multiselect: true,
      clearable: true,
      sort: "asc"
    },
    headerFilterFunc: (headerValue: any, rowValue: any) => {
      if (!headerValue || headerValue.length === 0) return true;
      if (Array.isArray(headerValue)) {
        return headerValue.includes(rowValue);
      }
      return headerValue === rowValue;
    },
    headerFilterPlaceholder: "Selecione...",
    formatter: (cell: any) => {
      const data = cell.getData();
      const local = data.Local || "-";

      // Se não há local, retornar "-"
      if (!data.Local || data.Local === "-") {
        return local;
      }

      // Verificar se é usuário Taggen e se há diferença entre Corporacao e CorpLocal
      if (isTaggenUser && data.Corporacao && data.CorpLocal && data.Corporacao !== data.CorpLocal) {
        return `<span><i class="ui yellow icon exclamation triangle" style="padding: 2px"></i> ${local} (${data.CorpLocal})</span>`;
      }

      // Caso contrário, retornar o local normalmente
      return local;
    },
  },
  {
    title: "Descrição",
    field: "Descricao",
    sorter: "string",
    headerFilter: "input",
    headerFilterPlaceholder: "Digite para filtrar...",
    headerFilterLiveFilter: false,
  },
  {
    title: "Local Fixo/Movel",
    field: "PlaceType",
    sorter: "string",
    headerFilter: "list",
    headerFilterParams: {
      values: true,
      multiselect: true,
      clearable: true,
      sort: "asc"
    },
    headerFilterFunc: (headerValue: any, rowValue: any) => {
      if (!headerValue || headerValue.length === 0) return true;
      if (Array.isArray(headerValue)) {
        return headerValue.includes(rowValue);
      }
      return headerValue === rowValue;
    },
    headerFilterPlaceholder: "Selecione...",
    formatter: (cell: any) =>
      cell.getValue() === "Fixo"
        ? `<i class='ui icon building'></i> Fixo`
        : `<i class='ui icon car'></i> Movel`,
    hozAlign: "center",
  },
  {
    title: "Descrição do Local",
    field: "LocalDescricao",
    sorter: "string",
    headerFilter: "list",
    headerFilterParams: {
      values: true,
      multiselect: true,
      clearable: true,
      sort: "asc"
    },
    headerFilterFunc: (headerValue: any, rowValue: any) => {
      if (!headerValue || headerValue.length === 0) return true;
      if (Array.isArray(headerValue)) {
        return headerValue.includes(rowValue);
      }
      return headerValue === rowValue;
    },
    headerFilterPlaceholder: "Selecione...",
  },

  {
    title: "Coordenadas (LAT/LONG)",
    field: "Localizacao",
    formatter: (cell) => {
      const data = cell.getRow().getData();
      // Usar LastLatitude e LastLongitude se disponíveis, senão usar Latitude e Longitude
      const lat = data.LastLatitude != null ? data.LastLatitude : data.Latitude;
      const lng = data.LastLongitude != null ? data.LastLongitude : data.Longitude;

      if (
        lat != null &&
        lng != null &&
        lat !== 0 &&
        lng !== 0
      ) {
        return `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
      }
      return " - ";
    },
    hozAlign: "center",
  },

  {
    title: "Temperatura Cº",
    field: "Temperatura",
    sorter: "number",
    headerFilter: "input",
    headerFilterLiveFilter: false,
    formatter: (cell: CellComponent) => {
      const value = cell.getValue();
      const rowData = cell.getRow().getData();
      const ultimaVisualizacao = rowData.UltimaVisualizacao;
      const temperatura = value !== null && value !== undefined ? parseInt(value, 10) : null;

      // Função para parsear data no formato DD/MM/YYYY
      const parseDataBR = (dateStr: string): Date | null => {
        if (!dateStr) return null;
        try {
          const parts = dateStr.split('/');
          if (parts.length !== 3) return null;
          const dia = parseInt(parts[0], 10);
          const mes = parseInt(parts[1], 10) - 1; // mês começa do 0
          const ano = parseInt(parts[2], 10);
          return new Date(ano, mes, dia);
        } catch (error) {
          console.error(`\u274c Erro ao parsear data: ${dateStr}`, error);
          return null;
        }
      };

      // Verificar primeiro se temperatura é 0 e última atualização foi há mais de 1 mês
      if (temperatura === 0 && ultimaVisualizacao) {
        try {
          const dataAtualizacao = parseDataBR(ultimaVisualizacao);
          const dataAtual = new Date();

          if (dataAtualizacao) {
            // Calcular diferença em milissegundos
            const diferenca = dataAtual.getTime() - dataAtualizacao.getTime();
            // Converter para dias (30 dias = 1 mês)
            const dias = diferenca / (1000 * 60 * 60 * 24);

            if (dias > 30) {
              return '<div style="margin: auto; width: 60%; text-align: center;">-</div>';
            }
          }
        } catch (error) {
          console.error('\u274c [TEMP] Erro ao processar data de temperatura:', error);
        }
      }

      if (isEmpty(value)) {
        return '<div style="margin: auto; width: 60%; text-align: center;">-</div>';
      }

      if (temperatura && temperatura > 80) {
        return '<span><i class="ui icon thermometer full" style="color: #C71585; padding: 2px"></i>' + value + '°C</span>';
      } else if (temperatura && temperatura > 70 && temperatura < 80) {
        return '<span><i class="ui icon thermometer half" style="color: gold; padding: 2px"></i>' + value + '°C</span>';
      } else {
        return '<span><i class="ui icon thermometer empty" style="color: aqua; padding: 2px"></i>' + value + '°C</span>';
      }
    },
    hozAlign: "center",
  },
  {
    title: "Nível da bateria",
    field: "Bateria",
    sorter: "number",
    headerFilter: "input",
    headerFilterLiveFilter: false,
    formatter: (cell: CellComponent) => {
      const value = cell.getValue();
      const rowData = cell.getRow().getData();
      const ultimaVisualizacao = rowData.UltimaVisualizacao;
      let bateria = value !== null && value !== undefined ? parseInt(value, 10) : null;

      // Função para parsear data no formato DD/MM/YYYY
      const parseDataBR = (dateStr: string): Date | null => {
        if (!dateStr) return null;
        try {
          const parts = dateStr.split('/');
          if (parts.length !== 3) return null;
          const dia = parseInt(parts[0], 10);
          const mes = parseInt(parts[1], 10) - 1; // mês começa do 0
          const ano = parseInt(parts[2], 10);
          return new Date(ano, mes, dia);
        } catch (error) {
          console.error(`\u274c Erro ao parsear data: ${dateStr}`, error);
          return null;
        }
      };

      // Verificar primeiro se bateria é 0 e última atualização foi há mais de 1 mês
      if (bateria === 0 && ultimaVisualizacao) {
        try {
          const dataAtualizacao = parseDataBR(ultimaVisualizacao);
          const dataAtual = new Date();

          if (dataAtualizacao) {
            // Calcular diferença em milissegundos
            const diferenca = dataAtual.getTime() - dataAtualizacao.getTime();
            // Converter para dias (30 dias = 1 mês)
            const dias = diferenca / (1000 * 60 * 60 * 24);

            if (dias > 30) {
              return '<div style="margin: auto; width: 60%; text-align: center;">-</div>';
            }
          }
        } catch (error) {
          console.error('\u274c [BAT] Erro ao processar data de bateria:', error);
        }
      }

      if (isEmpty(value)) {
        return '<div style="margin: auto; width: 60%; text-align: center;">-</div>';
      }

      // Garantir que o valor da bateria esteja entre 0 e 100
      if (bateria !== null) {
        bateria = Math.max(0, Math.min(100, bateria));
      }

      if (bateria && bateria >= 75 && bateria <= 100) {
        return '<span><i class="ui icon battery full" style="color: green; margin-right: 6px;"></i>' + bateria + '&nbsp;%</span>';
      } else if (bateria && bateria >= 50 && bateria <= 74) {
        return '<span><i class="ui icon battery three quarters" style="color: #FFA500; margin-right: 6px;"></i>' + bateria + '&nbsp;%</span>';
      } else if (bateria && bateria >= 25 && bateria <= 49) {
        return '<span><i class="ui icon battery half" style="color: #FFD700; margin-right: 6px;"></i>' + bateria + '&nbsp;%</span>';
      } else if (bateria && bateria >= 0 && bateria <= 24) {
        return '<span><i class="ui icon battery quarter" style="color: #FF4500; margin-right: 6px;"></i>' + bateria + '&nbsp;%</span>';
      } else {
        return '<span><i class="ui icon battery empty" style="color: #C71585; margin-right: 6px;"></i>' + bateria + '&nbsp;%</span>';
      }
    },
    hozAlign: "center",
  },
  ];


  useEffect(() => {
    const initializeTable = async () => {
      if (!tableRef.current) return;

      if (mainTableRef.current) {
        mainTableRef.current.destroy();
        mainTableRef.current = null;
      }

      console.log("Inicializando tabela...");

      // 1. Obter nome da corporação para buscar configuração
      const corpObj = availableCorporations.find(c => c.id === selectedCorporation);
      const corporationName = corpObj ? corpObj.name : "";

      let colunasConfiguradas: any[] = [];

      // 2. Buscar configurações na API (labels)
      if (corporationName) {
        try {
          const response = await httpClient.request({
            method: RequestMethod.GET,
            endpoint: `/api/labels/TABELA_ATIVOS/${corporationName}`
          });

          if (response.success && response.payload) {
            colunasConfiguradas = response.payload;
            console.log("Configurações de colunas carregadas:", colunasConfiguradas);
          }
        } catch (error) {
          console.error("Erro ao carregar labels:", error);
        }
      }

      // 3. Buscar cache de colunas (visibilidade + ordem) – Tabela_Ativos
      let columnsVisibility: Record<string, boolean> = {};
      let columnsOrder: string[] = [];
      if (cacheUserId) {
        try {
          const cacheResponse = await httpClient.request({
            method: RequestMethod.GET,
            endpoint: `/api/Cache/${SCREEN_CODE_TABELA_ATIVOS}?userId=${cacheUserId}`,
          });
          const parsed = extractCacheJson(cacheResponse);
          if (parsed && typeof parsed === "object") {
            if (parsed.columnsVisibility && typeof parsed.columnsVisibility === "object") {
              columnsVisibility = parsed.columnsVisibility;
            }
            if (Array.isArray(parsed.columnsOrder)) {
              columnsOrder = parsed.columnsOrder;
            }
          }
        } catch (e) {
          console.warn("Cache de colunas (Tabela_Ativos) indisponível, usando padrão.", e);
        }
      }

      // 4. Obter colunas base e aplicar títulos (labels)
      const columns = getBaseColumns();
      const columnsWithTitles: ColumnDefinition[] = columns.map(col => {
        const config = colunasConfiguradas.find(
          c => c.Field && col.field && c.Field.toLowerCase() === col.field.toLowerCase()
        );
        if (config && config.Title) {
          return { ...col, title: config.Title };
        }
        return col;
      });

      // 5. Aplicar ordem do cache (columnsOrder) e visibilidade (columnsVisibility)
      const byField: Record<string, ColumnDefinition> = {};
      columnsWithTitles.forEach(c => { if (c.field) byField[c.field] = c; });
      const orderedColumns: ColumnDefinition[] = columnsOrder.length
        ? [
            ...columnsOrder.map(f => byField[f]).filter(Boolean),
            ...columnsWithTitles.filter(c => c.field && !columnsOrder.includes(c.field)),
          ]
        : columnsWithTitles;
      const finalColumns: ColumnDefinition[] = orderedColumns.map(col => ({
        ...col,
        visible: col.field !== undefined ? (columnsVisibility[col.field] ?? true) : true,
      }));

      mainTableRef.current = new Tabulator(tableRef.current, {
        data: [],
        height: 650,
        layout: "fitData",
        movableColumns: true,
        resizableColumnFit: true,
        columnHeaderVertAlign: "top",
        // Footer com paginador posicionado à esquerda (removido contador de registros)
        footerElement: `<div style="display:flex;align-items:center;justify-content:flex-start;width:100%;">
      <div id="footer-paginator" class="tabulator-paginator" style="display:flex;align-items:center;"></div>
    </div>`,
        // Paginação local (substitui o progressive scroll)
        pagination: true,
        paginationMode: "local",
        paginationSize: 25,
        paginationSizeSelector: [10, 25, 50, 100],
        paginationButtonCount: 5,
        paginationCounter: "rows",
        renderVerticalBuffer: 300,
        keybindings: false,
        sortMode: "local",
        filterMode: "local",
        layoutColumnsOnNewData: false,
        placeholder: "Nenhum dado encontrado",
        debugInvalidOptions: false,
        debugEventsExternal: false,
        debugEventsInternal: false,
        initialSort: [],
        // Traduções e textos do paginador em português
        locale: true,
        langs: {
          "default": {
            pagination: {
              first: "Primeira",
              first_title: "Primeira Página",
              last: "Última",
              last_title: "Última Página",
              prev: "Anterior",
              prev_title: "Página Anterior",
              next: "Próxima",
              next_title: "Próxima Página",
              page_size: ".",
              page_title: "Mostrar Página",
              all: "Todos",
              counter: {
                showing: "Mostrando",
                of: "de",
                rows: "registros",
                pages: "páginas"
              }
            }
          }
        },
        selectable: true, // Habilitar seleção de linhas
        selectableRollingSelection: false, // Desabilitar seleção múltipla por shift/ctrl
        selectableCheck: () => true, // Permitir seleção de todas as linhas

        columns: finalColumns,
      });

      // Registrar listeners para atualizar o footer e exibir paginação corretamente
      try {
        // Não atualizar texto de contador (removido) — manter apenas logs e garantir posicionamento do paginador
        mainTableRef.current.on && mainTableRef.current.on('dataLoaded', function (data: any) {
          console.log('dataLoaded eventos:', Array.isArray(data) ? data.length : 0);
          // garantir que o paginador esteja no container correto
          try {
            const footerP = document.getElementById('footer-paginator');
            const footerEl = mainTableRef.current.element.querySelector('.tabulator-footer');
            if (footerP && footerEl) {
              const paginator = footerEl.querySelector('.tabulator-paginator');
              if (paginator && footerP !== paginator.parentElement) {
                footerP.innerHTML = '';
                footerP.appendChild(paginator);
              }
            }
          } catch (err) { }
        });

        mainTableRef.current.on && mainTableRef.current.on('dataFiltered', function (filters: any, rows: any[]) {
          console.log('dataFiltered eventos - rows:', rows?.length);
        });

        mainTableRef.current.on && mainTableRef.current.on('pageLoaded', function (pageno: number) {
          console.log('pageLoaded:', pageno);
        });
      } catch (e) {
        // silencioso: se a API .on não existir, não quebra a execução
        console.warn('Não foi possível registrar listeners do Tabulator para atualizar footer.', e);
      }

      // Registra os eventos apenas uma vez
      mainTableRef.current.on("tableBuilt", function () {
        console.log("🏗️ Tabela construída com sucesso");

        const movePaginator = () => {
          try {
            const footerP = document.getElementById('footer-paginator');
            const footerEl = mainTableRef.current?.element?.querySelector('.tabulator-footer') || document.querySelector('.tabulator-footer');
            if (!footerEl) return false;

            // procura por qualquer paginador existente no documento
            let paginator = document.querySelector('.tabulator-paginator');

            // se encontrou um paginador e ele ainda não está no footerP, move
            if (paginator && footerP) {
              if (footerP !== paginator.parentElement) {
                footerP.innerHTML = '';
                footerP.appendChild(paginator);
              }
              return true;
            }

            // se não temos footerP, cria um no início do footer
            if (!footerP && footerEl) {
              const newP = document.createElement('div');
              newP.id = 'footer-paginator';
              newP.className = 'tabulator-paginator';
              newP.style.display = 'flex';
              newP.style.alignItems = 'center';
              footerEl.insertBefore(newP, footerEl.firstChild);
            }

            return false;
          } catch (err) {
            console.warn('Erro ao mover paginador para footer-paginator', err);
            return false;
          }
        };

        // Tenta mover imediatamente e novamente após pequeno delay para cobrir re-renders do Tabulator
        if (!movePaginator()) {
          setTimeout(movePaginator, 120);

          // fallback: observar mudanças no DOM por curto período e mover quando aparecer
          const observer = new MutationObserver((mutations, obs) => {
            if (movePaginator()) {
              obs.disconnect();
            }
          });
          observer.observe(document.body, { childList: true, subtree: true });
          // desconecta após 2s para evitar overhead permanente
          setTimeout(() => observer.disconnect(), 2000);
        }

        // Não carrega dados automaticamente - os dados serão carregados pelos filtros de organização
        // obterMapaAtivo(); // REMOVIDO para evitar carregar dados incorretos
      });

      mainTableRef.current.on("dataLoaded", function (data: IAtivosModel[]) {
        if (data.length > 0) {
          console.log('🔄 Atualizando filtros das colunas com', data.length, 'registros');

          // Atualiza as opções dos filtros
          const uniqueOrganizacoes = Array.from(new Set(data.map(item => item.Organizacao)))
            .filter(Boolean)
            .sort();

          const uniqueAtivos = Array.from(new Set(data.map(item => item.Ativo)))
            .filter(Boolean)
            .sort();

          const uniqueBeacons = Array.from(new Set(data.map(item => item.IdBeacon)))
            .filter(Boolean)
            .sort();

          const uniqueAtivoSituacoes = Array.from(new Set(data.map(item => item.AtivoSituacao)))
            .filter(Boolean)
            .sort();

          const uniqueStatusGateways = Array.from(new Set(data.map(item => item.StatusGateway)))
            .filter(Boolean)
            .sort();

          const uniqueLocais = Array.from(new Set(data.map(item => item.Local)))
            .filter(Boolean)
            .sort();

          const uniqueDescricoes = Array.from(new Set(data.map(item => item.Descricao)))
            .filter(Boolean)
            .sort();

          const uniquePlaceTypes = Array.from(new Set(data.map(item => item.PlaceType)))
            .filter(Boolean)
            .sort();

          const uniqueLocalDescricoes = Array.from(new Set(data.map(item => item.LocalDescricao)))
            .filter(Boolean)
            .sort();

          console.log('📊 Valores únicos encontrados:', {
            organizacoes: uniqueOrganizacoes.length,
            ativos: uniqueAtivos.length,
            beacons: uniqueBeacons.length,
            situacoes: uniqueAtivoSituacoes.length,
            status: uniqueStatusGateways.length,
            locais: uniqueLocais.length,
            descricoes: uniqueDescricoes.length,
            placeTypes: uniquePlaceTypes.length,
            localDescricoes: uniqueLocalDescricoes.length
          });

          // Atualiza as definições das colunas com os valores únicos
          try {
            mainTableRef.current.updateColumnDefinition("Organizacao", {
              headerFilterParams: {
                values: uniqueOrganizacoes,
                multiselect: true,
                clearable: true,
                sort: "asc"
              },
            });
            console.log('✅ Organizacao atualizada com', uniqueOrganizacoes.length, 'valores');

            mainTableRef.current.updateColumnDefinition("Ativo", {
              headerFilterParams: {
                values: uniqueAtivos,
                multiselect: true,
                clearable: true,
                sort: "asc"
              },
            });
            console.log('✅ Ativo atualizada com', uniqueAtivos.length, 'valores');

            mainTableRef.current.updateColumnDefinition("IdBeacon", {
              headerFilterParams: {
                values: uniqueBeacons,
                multiselect: true,
                clearable: true,
                sort: "asc"
              },
            });
            console.log('✅ IdBeacon atualizada com', uniqueBeacons.length, 'valores');

            mainTableRef.current.updateColumnDefinition("AtivoSituacao", {
              headerFilterParams: {
                values: uniqueAtivoSituacoes,
                multiselect: true,
                clearable: true,
                sort: "asc"
              },
            });
            console.log('✅ AtivoSituacao atualizada com', uniqueAtivoSituacoes.length, 'valores');

            mainTableRef.current.updateColumnDefinition("StatusGateway", {
              headerFilterParams: {
                values: uniqueStatusGateways,
                multiselect: true,
                clearable: true,
                sort: "asc"
              },
            });
            console.log('✅ StatusGateway atualizada com', uniqueStatusGateways.length, 'valores');

            mainTableRef.current.updateColumnDefinition("Local", {
              headerFilterParams: {
                values: uniqueLocais,
                multiselect: true,
                clearable: true,
                sort: "asc"
              },
            });
            console.log('✅ Local atualizada com', uniqueLocais.length, 'valores');

            mainTableRef.current.updateColumnDefinition("Descricao", {
              headerFilterParams: {
                values: uniqueDescricoes,
                multiselect: true,
                clearable: true,
                sort: "asc"
              },
            });
            console.log('✅ Descricao atualizada com', uniqueDescricoes.length, 'valores');

            mainTableRef.current.updateColumnDefinition("PlaceType", {
              headerFilterParams: {
                values: uniquePlaceTypes,
                multiselect: true,
                clearable: true,
                sort: "asc"
              },
            });
            console.log('✅ PlaceType atualizada com', uniquePlaceTypes.length, 'valores');

            mainTableRef.current.updateColumnDefinition("LocalDescricao", {
              headerFilterParams: {
                values: uniqueLocalDescricoes,
                multiselect: true,
                clearable: true,
                sort: "asc"
              },
            });
            console.log('✅ LocalDescricao atualizada com', uniqueLocalDescricoes.length, 'valores');

            console.log('✅ Todos os filtros atualizados com sucesso');
          } catch (error) {
            console.error('❌ Erro ao atualizar filtros:', error);
          }

          loadConfigTable();
        }
      });

      mainTableRef.current.on("dataFiltered", function (filters: any, rows: any[]) {
        console.log('🔍 Filtros aplicados:', filters);
        console.log('📊 Linhas filtradas:', rows.length);
        setRegistrosFiltrados(rows.length);
        // Atualiza o footer com a contagem de registros
        atualizarFooterTabela(rows.length);
      });

      mainTableRef.current.on("error", function (error: Error) {
        console.error('❌ Erro na tabela:', error);
      });

      mainTableRef.current.on("rowClick", (e: Event, row: any) => {
        console.log('🖱️ Linha clicada:', row.getData());
        handleRowClick(e, row);
      });
    }
    initializeTable();

  }, [selectedCorporation, cacheUserId]); 

  // Adiciona um useEffect separado para atualizar dados quando listaAtivo mudar
  useEffect(() => {
    if (mainTableRef.current) {
      if (listaAtivo.length > 0) {
        console.log('🔄 Atualizando tabela com', listaAtivo.length, 'registros');
        mainTableRef.current.replaceData(listaAtivo);
      }
      // Sempre atualizar o footer, mesmo se listaAtivo estiver vazio
      setTimeout(() => atualizarFooterTabela(), 100);
    }
  }, [listaAtivo]);

  // useEffect removido - dados serão carregados pelos filtros de organização

  const handleSettingsClick = () => {
    console.log('⚙️ Alternando sidebar de configurações');
    setSidebarVisible(!sidebarVisible);
    if (!sidebarVisible) {
      setTimeout(loadConfigTable, 300);
    }
  };
  // Função removida - agora usa filtros globais
  // aplicarFiltroOrganizacoes não é mais necessária

  const applyConfigChanges = async () => {
    console.log('⚙️ Aplicando mudanças de configuração');
    const updatedCols = configTableRefInstance.current.getData();

    const newColumns = updatedCols.map((col: any) => {
      const originalCol = mainTableRef.current.getColumn(col.field);
      if (originalCol) {
        const definition = originalCol.getDefinition();
        return {
          ...definition,
          visible: col.visible,
        };
      }
      return col;
    });

    mainTableRef.current.setColumns(newColumns);
    console.log('✅ Configurações aplicadas com sucesso');

    // Persistir visibilidade e ordem no cache Tabela_Ativos
    const visibility: Record<string, boolean> = {};
    const order: string[] = [];
    mainTableRef.current.getColumns().forEach((col: ColumnComponent) => {
      const field = col.getField();
      if (field) {
        visibility[field] = col.isVisible();
        order.push(field);
      }
    });
    await saveTableColumnsCache(visibility, order);
  };

  const handleDownloadCsv = () => {
    console.log('📥 Fazendo download do CSV');
    try {
      mainTableRef.current.download("csv", "ativos.csv");
      console.log('✅ Download do CSV iniciado');
    } catch (error) {
      console.error('❌ Erro ao fazer download do CSV:', error);
    }
  };

  // Função para limpar seleção de linhas
  const clearRowSelection = () => {
    if (mainTableRef.current) {
      const selectedRows = mainTableRef.current.getSelectedRows();
      console.log('🧹 Limpando seleção de', selectedRows.length, 'linhas');
      selectedRows.forEach((selectedRow: any) => {
        selectedRow.deselect();
      });
    }
  };

  // Função simplificada para limpar filtros
  const handleClearFilters = () => {
    console.log('🧹 Limpando todos os filtros');
    // Limpar ativos
    setSelectedAtivos([]);

    // Limpar seleção de linhas
    clearRowSelection();

    // Limpar os filtros do cabeçalho da tabela
    if (mainTableRef.current) {
      const columns = mainTableRef.current.getColumns();
      console.log('🧹 Limpando filtros de', columns.length, 'colunas');
      columns.forEach((column: any) => {
        try {
          column.setHeaderFilterValue('');
        } catch (e) {
          console.log(`Erro ao limpar filtro da coluna ${column.getField()}:`, e);
        }
      });
      console.log('✅ Filtros limpos com sucesso');
    }
  };

  // Funções removidas - agora usa filtros globais
  // handleCorporationChange e handleOrganizationChange não são mais necessárias

  // Função para alternar entre as abas
  const handleTabChange = (tab: string) => {
    console.log('📑 Alternando para aba:', tab);
    setActiveTab(tab);
  };

  // Estilos para as abas
  const tabButtonStyles = {
    container: {
      display: 'flex',
      gap: '1px',
      backgroundColor: '#f8f9fa',
      padding: '10px',
      borderRadius: '4px',
      marginBottom: '15px'
    },
    button: {
      flex: 1,
      padding: '10px 20px',
      border: 'none',
      backgroundColor: '#e9ecef',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      color: '#495057',
      borderRadius: '4px',
      fontWeight: 500
    },
    activeButton: {
      backgroundColor: '#007bff',
      color: 'white',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }
  };

  // Adicionar um useEffect para atualizar o mapa quando mudar de aba
  useEffect(() => {
    console.log('🗺️ useEffect - activeTab:', activeTab, 'selectedAtivo:', selectedAtivo?.Ativo);
    console.log('🗺️ useEffect - mapRef.current:', !!mapRef.current);
    console.log('🗺️ useEffect - markersGroup.current:', !!markersGroup.current);

    if (activeTab === 'mapa' && selectedAtivo && mapRef.current) {
      console.log('🗺️ useEffect - Inicializando markersGroup...');
      if (!markersGroup.current && mapRef.current) {
        markersGroup.current = L.layerGroup().addTo(mapRef.current);
        console.log('🗺️ markersGroup criado:', markersGroup.current);
      }

      // Verificar se o marcador ainda está no markersGroup
      const markerStillExists = currentAtivoMarkerRef.current &&
        markersGroup.current?.hasLayer(currentAtivoMarkerRef.current);

      if (!markerStillExists && markersGroup.current && ((selectedAtivo.LastLatitude || selectedAtivo.Latitude) || trackingDataAtivo)) {
        console.log('🗺️ Marcador não encontrado, recriando...');

        // Função async para buscar dados de tracking e criar marcador
        const recreateMarker = async () => {
          // Buscar dados de tracking se ainda não foram buscados
          // Usar LastLatitude e LastLongitude se disponíveis, senão usar Latitude e Longitude
          let latitude = selectedAtivo.LastLatitude != null ? selectedAtivo.LastLatitude : selectedAtivo.Latitude;
          let longitude = selectedAtivo.LastLongitude != null ? selectedAtivo.LastLongitude : selectedAtivo.Longitude;
          let metodo: string | undefined = undefined;
          let gatewayFromAPI: string | null = null;
          let lastSeenFromAPI: string | null = null;

          if (trackingDataAtivo) {
            // Usar dados de tracking já disponíveis
            const metodoTracking = trackingDataAtivo.Metodo ? trackingDataAtivo.Metodo.toLowerCase() : undefined;
            if (metodoTracking === 'estimado' || metodoTracking === 'centroide') {
              latitude = (trackingDataAtivo as IGatewayData).LatitudeAleatoria || trackingDataAtivo.Latitude;
              longitude = (trackingDataAtivo as IGatewayData).LongitudeAleatoria || trackingDataAtivo.Longitude;
            } else {
              latitude = trackingDataAtivo.Latitude;
              longitude = trackingDataAtivo.Longitude;
            }
            metodo = metodoTracking;
            // Obter Gateway e LastSeen do trackingDataAtivo
            gatewayFromAPI = (trackingDataAtivo as any).Gateway || null;
            lastSeenFromAPI = (trackingDataAtivo as any).LastSeen || null;
            console.log('✅ Usando dados de tracking já disponíveis:', { latitude, longitude, metodo, gatewayFromAPI, lastSeenFromAPI });
          } else if ((selectedAtivo.LastLatitude || selectedAtivo.Latitude) && (selectedAtivo.LastLongitude || selectedAtivo.Longitude)) {
            // Buscar dados de tracking agora
            console.log('📡 Buscando dados de tracking...');
            const trackingData = await fetchTrackingDataForAtivo(selectedAtivo);
            if (trackingData && trackingData.latitude && trackingData.longitude) {
              latitude = trackingData.latitude;
              longitude = trackingData.longitude;
              metodo = trackingData.metodo;
              gatewayFromAPI = trackingData.gateway || null;
              lastSeenFromAPI = trackingData.lastSeen || null;
              console.log('✅ Dados de tracking obtidos:', { latitude, longitude, metodo, gatewayFromAPI, lastSeenFromAPI });
            }
          }

          if (!latitude || !longitude || latitude === 0 || longitude === 0) {
            console.warn('⚠️ Não há coordenadas válidas para plotar o marcador');
            return;
          }

          // Verificar se há ícone em cache para restaurar imediatamente
          const cachedIcon = iconCacheRef.current.get(selectedAtivo.IdAtivo);

          // Criar marcador com ícone do cache ou fallback
          const initialIcon = cachedIcon || L.divIcon({
            className: 'custom-div-icon',
            html: `<div style="
              background-color: #3388ff !important; 
              width: 20px !important; 
              height: 20px !important; 
              border-radius: 50% !important; 
              border: 3px solid white !important; 
              box-shadow: 0 2px 6px rgba(0,0,0,0.4) !important;
              position: relative !important;
              z-index: 1000 !important;
              display: block !important;
              visibility: visible !important;
              opacity: 1 !important;
            "></div>`,
            iconSize: [26, 26],
            iconAnchor: [13, 13]
          });

          const marker = L.marker([latitude, longitude], {
            icon: initialIcon,
            zIndexOffset: 2000
          });

          // Usar dados da API se disponíveis, senão usar dados do PowerBI
          const gatewayDisplay = gatewayFromAPI || selectedAtivo.Gateway || "-";
          const ultimaVisualizacaoDisplay = lastSeenFromAPI ? ajustarHorario(lastSeenFromAPI) : ajustarHorario(selectedAtivo.UltimaVisualizacao);

          // Armazenar a Última Visualização para uso na aba de movimentação
          // Converter para formato DD/MM/YYYY HH:mm:ss para comparação
          const ultimaVisualizacaoParaComparacao = lastSeenFromAPI || selectedAtivo.UltimaVisualizacao;
          if (ultimaVisualizacaoParaComparacao) {
            setUltimaVisualizacaoPopup(ultimaVisualizacaoDisplay);
          }

          const popup = L.popup().setContent(`
            <div style="text-align: left;">
            <b>Gateway:</b> ${gatewayDisplay}<br>
            <b>Última Visualização:</b> ${ultimaVisualizacaoDisplay}<br>
            <b>Ativo:</b> ${selectedAtivo.Ativo}<br>
            <b>Local:</b> ${selectedAtivo.Local || "-"}<br>
            <b>Latitude:</b> ${latitude.toFixed(6)}<br>
            <b>Longitude:</b> ${longitude.toFixed(6)}<br>
            ${metodo ? `<b>Método:</b> ${metodo.toUpperCase()}<br>` : ''}
            <b>Status:</b> ${selectedAtivo.Status || "-"}<br>
            <br><i>Clique no marcador para ver círculos de cobertura</i>
          `);

          marker.bindPopup(popup).openPopup();

          // Adicionar evento de clique no marcador
          marker.on('click', async () => {
            console.log('🖱️ Clique no marcador do ativo:', selectedAtivo.Ativo);
            console.log('🔄 Chamando APIs e desenhando círculos...');

            if (!mapRef.current || !mapRef.current.getContainer()) {
              console.warn('🗺️ ⚠️ Mapa não está pronto, aguardando...');
              await new Promise(resolve => setTimeout(resolve, 500));
            }

            plotGatewayAndBeaconData(selectedAtivo);
          });

          if (markersGroup.current) {
            markersGroup.current.addLayer(marker);
            currentAtivoMarkerRef.current = marker;

            // Se não havia ícone em cache, buscar agora
            if (!cachedIcon) {
              lastSelectedAtivoIdRef.current = selectedAtivo.IdAtivo;
              const controller = new AbortController();
              iconFetchAbortRef.current = controller;

              fetchIconForAtivo(selectedAtivo.IdAtivo, controller.signal)
                .then((customIcon) => {
                  if (!customIcon) return;
                  if (lastSelectedAtivoIdRef.current !== selectedAtivo.IdAtivo) return;
                  if (marker && markersGroup.current?.hasLayer(marker)) {
                    marker.setIcon(customIcon);
                    console.log('✅ Ícone personalizado restaurado do cache/API');
                  }
                })
                .catch(() => { /* silencioso */ });
            } else {
              console.log('✅ Ícone restaurado do cache');
            }

            // Centralizar mapa na posição do ativo
            // Adicionar um pequeno delay para garantir que o mapa esteja totalmente renderizado
            setTimeout(() => {
              if (mapRef.current && latitude && longitude) {
                mapRef.current.setView([latitude, longitude], 15);
                console.log('✅ Marcador recriado e ícone restaurado, mapa centralizado');
              }
            }, 100);
          }
        };

        // Executar função async
        recreateMarker();
      } else if (markerStillExists && currentAtivoMarkerRef.current) {
        // Se o marcador ainda existe, obter suas coordenadas e centralizar
        const markerPosition = currentAtivoMarkerRef.current.getLatLng();
        if (markerPosition) {
          setTimeout(() => {
            if (mapRef.current) {
              mapRef.current.setView([markerPosition.lat, markerPosition.lng], 15);
              console.log('✅ Marcador ainda está no mapa, centralizando na posição do ativo');
            }
          }, 100);
        }
      }
    }
  }, [activeTab, selectedAtivo, trackingDataAtivo]);

  // Adicionar um useEffect para buscar comentários quando um alerta é selecionado
  useEffect(() => {
    if (selectedAlert) {
      obterComentarios(selectedAlert.IdWorkFlow);
    }
  }, [selectedAlert]);

  // Adicionar função para buscar usuário
  const obterUsuario = async (idUser: number | null) => {
    if (!idUser) {
      console.log('⚠️ ID de usuário inválido');
      return null;
    }
    console.log('👤 Obtendo dados do usuário:', idUser);
    try {
      const response = await fetch(
        `${backendUrl}/api/User/${idUser}`,
        {
          method: "GET",
          headers: {
            'Accept': 'application/json',
            'Authorization': `Bearer ${auth?.Token}`
          }
        }
      );
      if (response.ok) {
        const userData = await response.json();
        console.log('✅ Dados do usuário obtidos:', userData);
        return userData;
      }
      console.warn('⚠️ Erro ao obter dados do usuário:', response.status);
      return null;
    } catch (error) {
      console.error('❌ Erro ao obter dados do usuário:', error);
      return null;
    }
  };

  // Função para buscar os chamados do ativo
  const obterChamadosAtivo = async (ativo: string) => {
    console.log('📞 Obtendo chamados para ativo:', ativo);
    try {
      const response = await fetch(`${backendUrl}/api/PrismWorkFlow/ByAtivo/${ativo}`, {
        method: 'GET',
        headers: {
          'Accept': '*/*',
        },
      });

      if (response.ok) {
        const data = await response.json();
        // Filtra os dados com base no selectedAtivo
        const filteredData = data.filter((item: any) => {
          try {
            const parsedData = JSON.parse(item.Dados);
            return parsedData.Ativo === ativo;
          } catch (e) {
            console.error('Erro ao parsear JSON:', e);
            return false;
          }
        });

        // Buscar nomes dos usuários para cada chamado
        const chamadosComUsuarios = await Promise.all(
          filteredData.map(async (chamado: any) => {
            const [usuarioOwner, usuarioResponsible] = await Promise.all([
              obterUsuario(chamado.IdUsuarioOwner),
              obterUsuario(chamado.IdUsuarioResponsible)
            ]);

            return {
              ...chamado,
              UsuarioOwner: usuarioOwner?.Name || 'Não identificado',
              UsuarioResponsible: usuarioResponsible?.Name || 'Não atribuído',
              TotalRecords: chamado.TotalRecords || 0
            };
          })
        );

        setChamadosAtivo(chamadosComUsuarios);
      }
    } catch (error) {
      // Erro silencioso
    }
  };

  // Função para buscar comentários
  const obterComentarios = async (idWorkFlow: string) => {
    console.log('💬 Obtendo comentários para workflow:', idWorkFlow);
    try {
      const response = await fetch(
        `${backendUrl}/api/PrismWorkFlowUser/ByWorkFlow/${idWorkFlow}`,
        {
          method: "GET",
        }
      );
      const responseJson = await response.json();

      // Buscar os dados do usuário para cada comentário
      const comentariosComUsuarios = await Promise.all(
        responseJson.map(async (comentario: any) => {
          const usuario = await obterUsuario(comentario.IdUser);
          return {
            ...comentario,
            Name: usuario?.Name || 'Usuário não identificado'
          };
        })
      );

      setComents(comentariosComUsuarios);
    } catch (error) {
      // Erro silencioso
    }
  };

  const obterMovimentacoesAtivo = async (
    IdAtivo: number,
    idOrganizacao: number,
    corporacao: string,
    organizacao: string,
    nomeAtivo: string
  ) => {
    try {
      console.log('📞 Obtendo movimentações para ativo:', nomeAtivo, 'da organização:', organizacao, 'corporação:', corporacao);

      // Inicializar com valor padrão
      let linhas = 4;

      // 1. Buscar limites de linhas primeiro
      console.log('🔍 Buscando limites de linhas...');
      const linhasResponse = await fetch(`${backendUrl}/api/LinhasMovimentacoesAtivos`, {
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${auth?.Token}`
        }
      });

      if (!linhasResponse.ok) {
        console.warn('⚠️ Erro ao obter limites de linhas, usando valor padrão:', linhas);
      } else {
        const linhasData = await linhasResponse.json();
        console.log('✅ Limites de linhas obtidos:', linhasData);
        console.log('🔍 Buscando organização ID:', idOrganizacao, '(tipo:', typeof idOrganizacao + ')');

        // Encontrar o número de linhas para a organização do ativo usando o ID
        const linhaOrg = linhasData.find(
          (l: any) => Number(l.IdOrganizacao) === Number(idOrganizacao)
        );

        if (linhaOrg) {
          linhas = Number(linhaOrg.Linhas);
          console.log('✅ Limite de linhas encontrado para organização ID', idOrganizacao, ':', linhas, 'linhas');
        } else {
          console.warn('⚠️ Organização não encontrada nos limites (ID:', idOrganizacao, '), usando valor padrão:', linhas);
        }
      }

      console.log('📊 Número de linhas para organização ID', idOrganizacao, ':', linhas);

      // Usar a nova API TrackingAdjusted
      const endpoint = `/api/trackingAdjusted/${encodeURIComponent(corporacao)}/${encodeURIComponent(organizacao)}/TrackingAdjusted`;
      const fullUrl = `${backendUrl}${endpoint}`;

      const requestBody = {
        Ativos: [nomeAtivo],
        Linhas: linhas,
        OffSet: 0
      };

      console.log('📡 Chamando nova API:', fullUrl);
      console.log('📦 Body da requisição:', JSON.stringify(requestBody, null, 2));

      const response = await fetch(fullUrl, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth?.Token}`
        },
        body: JSON.stringify(requestBody)
      });

      if (response.ok) {
        const data: ITrackingAdjustedResponse[] = await response.json();
        console.log('✅ Movimentações obtidas com sucesso da nova API:', data.length, 'registros');

        // Mapear os dados da nova API para o formato esperado pela tabela
        const mappedData: IMovimentacao[] = data.map((item) => {
          // Converter StayMinutes para formato de tempo legível
          const horas = Math.floor(item.StayMinutes / 60);
          const minutos = item.StayMinutes % 60;
          const dias = Math.floor(horas / 24);
          const horasRestantes = horas % 24;

          let permanencia = '';
          // Se minutos for 0, mostrar "< 1 min"
          if (item.StayMinutes === 0) {
            permanencia = '< 1 min';
          } else if (dias > 0) {
            const partes: string[] = [];
            if (dias > 0) partes.push(`${dias} dia${dias > 1 ? 's' : ''}`);
            if (horasRestantes > 0) partes.push(`${horasRestantes} hs`);
            if (minutos > 0) partes.push(`${minutos} min`);
            permanencia = partes.join(' e ');
          } else if (horas > 0) {
            const partes: string[] = [];
            partes.push(`${horas} hs`);
            if (minutos > 0) partes.push(`${minutos} min`);
            permanencia = partes.join(' e ');
          } else {
            permanencia = `${minutos} min`;
          }

          // Converter data do formato brasileiro (DD/MM/YYYY HH:mm:ss) para Date
          const parseDataBrasileira = (dataStr: string | null): Date | null => {
            if (!dataStr) return null;

            // Formato: DD/MM/YYYY HH:mm:ss
            const match = dataStr.match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/);
            if (match) {
              const [, day, month, year, hour, minute, second] = match;
              return new Date(
                parseInt(year),
                parseInt(month) - 1,
                parseInt(day),
                parseInt(hour),
                parseInt(minute),
                parseInt(second)
              );
            }

            // Tentar parsear como ISO se não for formato brasileiro
            const date = new Date(dataStr);
            return isNaN(date.getTime()) ? null : date;
          };

          // Usar PreviousLastSeen como data de entrada (TrackingDate)
          const trackingDate = parseDataBrasileira(item.PreviousLastSeen) ||
            parseDataBrasileira(item.CurrentLastSeen) ||
            new Date();

          return {
            tracking: {
              Id: 0,
              TrackingDate: trackingDate as any, // Será formatado na tabela
              IdPrism: item.IdPrism,
              Beacon: '',
              Plate: item.Ativo,
              IdPlaceArrive: 0,
              IdPlaceLeave: 0,
              PlaceLeave: '',
              PermanenceTime: item.StayMinutes,
              Permanence: permanencia,
              IdGateway: 0,
              Gateway: '',
              Rssi: 0,
              TxPower: '',
              IdOrganization: idOrganizacao,
              latitude: item.LastLatitude || 0,
              longitude: item.LastLongitude || 0,
              Processo: 0,
              IdPlaceArriveNavigation: null,
              IdPrismNavigation: null
            },
            place: {
              Id: 0,
              Name: item.Local || '', // Pode ser null
              Description: item.Status || '', // Usar Status como descrição
              IdOrganization: idOrganizacao,
              IsNeutralPlace: false,
              IsTransitPlace: false,
              IsVehicle: false,
              Disable: false,
              beaconsgroup: [],
              placealerts: [],
              placegateway: [],
              placeorgchanges: [],
              placetags: [],
              placeworkflow: [],
              tracking: []
            },
            InfoAdicional: item.Status || '', // Usar Status no lugar de InfoAdicional
            ItemAssociado: item.ItemAssociado || null,
            CurrentLastSeen: item.CurrentLastSeen || null // Preservar CurrentLastSeen para comparação
          };
        });

        if (mappedData.length > 0) {
          console.log('📊 Dados mapeados com sucesso:', mappedData.length, 'registros');
          console.log('📊 Primeiro registro mapeado:', JSON.stringify(mappedData[0], null, 2));
          setMovimentacoes(mappedData);
        } else {
          console.log('⚠️ API retornou dados, mas nenhum válido após mapeamento');
          console.log('⚠️ Dados originais recebidos:', data);
          setMovimentacoes([]);
        }
      } else {
        const errorText = await response.text();
        console.error('❌ Erro na nova API:', response.status, errorText);
        setMovimentacoes([]);
      }
    } catch (error) {
      console.error("❌ Erro geral na requisição de movimentações:", error);
      setMovimentacoes([]);
    }
  };

  // Função para consultar dados de beacon (GPS) baseado no ativo selecionado
  const fetchBeaconTrackingData = async (ativoData: IAtivosModel) => {
    try {
      let dataHoraUltimaVisualizacao = formatarDataHoraParaAPI(ativoData.UltimaVisualizacao);
      console.log('📅 [BeaconNred] Data original:', ativoData.UltimaVisualizacao);
      console.log('📅 [BeaconNred] Data e hora formatada:', dataHoraUltimaVisualizacao);

      // Buscar o nome da corporação selecionada
      const corporacaoNome = selectedCorporation
        ? availableCorporations.find(corp => corp.id === selectedCorporation)?.name
        : ativoData.Corporacao;

      const orgsToSend = selectedOrganizations.length > 0
        ? selectedOrganizations
        : (ativoData.Organizacao ? [ativoData.Organizacao] : []);

      const payload = {
        Corporacao: corporacaoNome,
        Organizacao: orgsToSend,
        Ativos: [ativoData.Ativo],
        Interferencia: 3,
        dtfinal: dataHoraUltimaVisualizacao
      };

      console.log('📡 [BeaconNred] Enviando payload:', JSON.stringify(payload, null, 2));

      const response = await fetch(`${backendUrl}/api/BeaconNred`, {
        method: 'POST',
        headers: {
          'accept': 'application/json',
          'Content-Type': 'application/json-patch+json',
          'Authorization': `Bearer ${auth?.Token}`
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("❌ [BeaconNred] Erro na API:", errorText);
        setBeaconData([]);
        return [];
      }

      const responseData = await response.json();
      console.log('📥 [BeaconNred] Resposta bruta recebida:', responseData);
      console.log('📥 [BeaconNred] Tipo da resposta:', typeof responseData);

      // 1. Tenta fazer o parse se for string
      let parsedData = responseData;
      if (typeof responseData === 'string') {
        console.log('📝 [BeaconNred] Resposta é string, fazendo parse...');
        try {
          parsedData = JSON.parse(responseData);
          console.log('✅ [BeaconNred] Parse bem-sucedido:', parsedData);
        } catch (e) {
          console.error("❌ [BeaconNred] Erro ao parsear string JSON:", e);
          setBeaconData([]);
          return [];
        }
      }

      console.log('🔍 [BeaconNred] Dados após parse:', parsedData);
      console.log('🔍 [BeaconNred] É array?', Array.isArray(parsedData));
      if (Array.isArray(parsedData)) {
        console.log('🔍 [BeaconNred] Tamanho do array:', parsedData.length);
        if (parsedData.length > 0) {
          console.log('🔍 [BeaconNred] Primeiro elemento:', parsedData[0]);
          console.log('🔍 [BeaconNred] Primeiro elemento é array?', Array.isArray(parsedData[0]));
        }
      }

      // 2. CORREÇÃO FUNDAMENTAL: Tratamento de Array Aninhado (Ex: [[dados], {metadata}])
      let dataToProcess = parsedData;
      if (Array.isArray(parsedData) && parsedData.length > 0 && Array.isArray(parsedData[0])) {
        console.log("📦 [BeaconNred] Detectada estrutura de array aninhado. Extraindo índice 0.");
        dataToProcess = parsedData[0];
        console.log('📦 [BeaconNred] Dados extraídos:', dataToProcess);
        console.log('📦 [BeaconNred] Tamanho dos dados extraídos:', dataToProcess.length);
      }

      if (!Array.isArray(dataToProcess)) {
        console.warn("⚠️ [BeaconNred] Dados processados não são um array:", dataToProcess);
        setBeaconData([]);
        return [];
      }

      if (dataToProcess.length === 0) {
        console.warn("⚠️ [BeaconNred] Array está vazio");
        setBeaconData([]);
        return [];
      }

      // 3. Processar dados convertendo Latitude e Longitude para números
      const processedData = dataToProcess.map((item: any) => {
        const processed = {
          ...item,
          Latitude: typeof item.Latitude === 'string' ? parseFloat(item.Latitude) : item.Latitude,
          Longitude: typeof item.Longitude === 'string' ? parseFloat(item.Longitude) : item.Longitude,
        };
        console.log('🔄 [BeaconNred] Item processado:', {
          Ativo: processed.Ativo,
          Latitude: processed.Latitude,
          Longitude: processed.Longitude,
          lat_long_origin: processed.lat_long_origin
        });
        return processed;
      });

      console.log(`✅ [BeaconNred] Dados processados: ${processedData.length} registros.`);
      console.log(`📊 [BeaconNred] Primeiro registro completo:`, processedData[0]);
      setBeaconData(processedData);
      return processedData;

    } catch (error) {
      console.error("❌ [BeaconNred] Erro na requisição:", error);
      setBeaconData([]);
      return [];
    }
  };

  // Função para consultar dados de gateway baseado no ativo selecionado
  const fetchGatewayTrackingData = async (ativoData: IAtivosModel) => {
    try {
      let dataHoraUltimaVisualizacao = formatarDataHoraParaAPI(ativoData.UltimaVisualizacao);
      console.log('📅 Data original:', ativoData.UltimaVisualizacao);
      console.log('📅 Data e hora formatada:', dataHoraUltimaVisualizacao);

      // Buscar o nome da corporação selecionada
      const corporacaoNome = selectedCorporation
        ? availableCorporations.find(corp => corp.id === selectedCorporation)?.name
        : ativoData.Corporacao;

      const orgsToSend = selectedOrganizations.length > 0
        ? selectedOrganizations
        : (ativoData.Organizacao ? [ativoData.Organizacao] : []);

      const payload = {
        Corporacao: corporacaoNome,
        Organizacao: orgsToSend,
        Ativos: [ativoData.Ativo],
        Interferencia: 3,
        dtfinal: dataHoraUltimaVisualizacao
      };

      console.log('📡 Enviando payload para GatewayNred:', JSON.stringify(payload, null, 2));

      const response = await fetch(`${backendUrl}/api/GatewayNred`, {
        method: 'POST',
        headers: {
          'accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth?.Token}`
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Erro na API GatewayNred:", errorText);

        // Tentar com payload alternativo se o primeiro falhar
        console.log('🔄 Tentando payload alternativo...');
        // Tentar com payload alternativo se o primeiro falhar
        const payloadAlternativo = {
          Corporacao: corporacaoNome,
          Organizacao: ativoData.Organizacao, // String em vez de array
          Ativos: ativoData.Ativo, // String em vez de array
          Interferencia: 3,
          dtfinal: dataHoraUltimaVisualizacao
        };

        console.log('📡 Enviando payload alternativo:', JSON.stringify(payloadAlternativo, null, 2));

        const response2 = await fetch(`${backendUrl}/api/GatewayNred`, {
          method: 'POST',
          headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth?.Token}`
          },
          body: JSON.stringify(payloadAlternativo)
        });

        if (!response2.ok) {
          const errorText2 = await response2.text();
          console.error("Erro na API GatewayNred (payload alternativo):", errorText2);
          setGatewayData([]);
          return [];
        }

        const responseData2 = await response2.json();
        if (Array.isArray(responseData2)) {
          console.log("📡 Dados de gateway obtidos (payload alternativo):", responseData2);
          setGatewayData(responseData2);
          return responseData2;
        }

        setGatewayData([]);
        return [];
      }

      const responseData = await response.json();

      let parsedData = responseData;
      if (typeof responseData === 'string') {
        try {
          parsedData = JSON.parse(responseData);
        } catch (e) {
          console.error("❌ [GatewayNred] Erro ao fazer parse da resposta:", e);
        }
      }

      // Verificar se também vem aninhado
      let dataToProcess = parsedData;
      if (Array.isArray(parsedData) && parsedData.length > 0 && Array.isArray(parsedData[0])) {
        console.log("📦 [GatewayNred] Detectada estrutura de array aninhado. Extraindo índice 0.");
        dataToProcess = parsedData[0];
      }

      if (!Array.isArray(dataToProcess)) {
        console.warn("⚠️ [GatewayNred] Resposta não é um array:", dataToProcess);
        setGatewayData([]);
        return [];
      }

      console.log("✅ [GatewayNred] Dados obtidos:", dataToProcess.length, "registros");
      console.log("📡 [GatewayNred] Estrutura do primeiro gateway:", dataToProcess[0]);
      setGatewayData(dataToProcess);
      return dataToProcess;

    } catch (error) {
      console.error("Erro na requisição GatewayNred:", error);
      setGatewayData([]);
      return [];
    }
  };

  // Função para plotar dados de gateway e beacon no mapa
  const plotGatewayAndBeaconData = async (ativoData: IAtivosModel) => {
    try {
      // Usar LastLatitude e LastLongitude se disponíveis, senão usar Latitude e Longitude
      const ativoLat = ativoData.LastLatitude != null ? ativoData.LastLatitude : ativoData.Latitude;
      const ativoLng = ativoData.LastLongitude != null ? ativoData.LastLongitude : ativoData.Longitude;
      console.log('🗺️ Iniciando plotGatewayAndBeaconData para ativo:', ativoData.Ativo);
      console.log('🗺️ Coordenadas do ativo:', ativoLat, ativoLng);

      // Aguardar o mapa estar completamente pronto
      const mapReady = await waitForMapReady();
      if (!mapReady) {
        console.error('🗺️ ❌ Mapa não ficou pronto após tempo limite!');
        return;
      }

      console.log('🗺️ ✅ Mapa está pronto para adicionar círculos');

      // Verificar se o mapa está completamente inicializado
      if (!mapRef.current) {
        console.error('🗺️ ❌ Mapa não está inicializado!');
        return;
      }

      // Aguardar um pequeno delay para garantir que o mapa está pronto
      await new Promise(resolve => setTimeout(resolve, 100));

      // Garantir que markersGroup está inicializado
      if (!markersGroup.current && mapRef.current) {
        console.log('🗺️ Inicializando markersGroup...');
        markersGroup.current = L.layerGroup().addTo(mapRef.current);
        console.log('🗺️ markersGroup inicializado:', markersGroup.current);
      }

      // Não limpar marcadores existentes - apenas adicionar círculos
      if (!markersGroup.current) {
        console.log('🗺️ Tentando criar markersGroup novamente...');
        markersGroup.current = L.layerGroup().addTo(mapRef.current);
        console.log('🗺️ markersGroup criado com sucesso:', markersGroup.current);
      }

      console.log('🗺️ Adicionando círculos ao mapa existente');

      // Verificar LastlatLongOrigin para determinar qual API chamar
      const lastlatLongOrigin = ativoData.LastlatLongOrigin || ativoData.LatLongOrigin;
      console.log('🔍 LastlatLongOrigin do ativo:', lastlatLongOrigin);

      let gatewayData: IGatewayData[] = [];
      let beaconData: IBeaconData[] = [];

      // Se LastlatLongOrigin for "B", chamar apenas BeaconNred
      if (lastlatLongOrigin === 'B' || lastlatLongOrigin === 'b') {
        console.log('📍 Chamando BeaconNred (LastlatLongOrigin = B)');
        beaconData = await fetchBeaconTrackingData(ativoData);
      }
      // Se LastlatLongOrigin for "G", chamar apenas GatewayNred
      else if (lastlatLongOrigin === 'G' || lastlatLongOrigin === 'g') {
        console.log('📍 Chamando GatewayNred (LastlatLongOrigin = G)');
        gatewayData = await fetchGatewayTrackingData(ativoData);
      }
      // Se não houver LastlatLongOrigin ou for outro valor, tentar ambas APIs (comportamento anterior)
      else {
        console.log('⚠️ LastlatLongOrigin não definido ou valor desconhecido, tentando ambas APIs');
        const [gatewayResult, beaconResult] = await Promise.all([
          fetchGatewayTrackingData(ativoData),
          fetchBeaconTrackingData(ativoData)
        ]);
        gatewayData = gatewayResult;
        beaconData = beaconResult;
      }

      console.log('🗺️ Dados obtidos - Gateways:', gatewayData?.length || 0, 'Beacons:', beaconData?.length || 0);

      // Não plotar novamente o ativo - ele já existe no mapa
      // O ativo já foi plotado pelo addMarkerToMap quando a linha foi clicada
      /*
      // Plotar o ativo selecionado primeiro (marcador principal)
      if (ativoData.Latitude && ativoData.Longitude && markersGroup.current) {
        console.log('🗺️ Plotando ativo selecionado:', ativoData.Ativo);
        const ativoMarker = L.marker([ativoData.Latitude, ativoData.Longitude], {
          icon: L.divIcon({
            className: 'custom-div-icon',
            html: `<div style="background-color: #3388ff; width: 20px; height: 20px; border-radius: 50%; border: 3px solid white; box-shadow: 0 3px 6px rgba(0,0,0,0.4);"></div>`,
            iconSize: [20, 20],
            iconAnchor: [10, 10]
          }),
          zIndexOffset: 2000 // Garantir que fique acima de tudo
        });

        const popup = L.popup().setContent(`
          <b>Ativo:</b> ${ativoData.Ativo}<br>
          <b>Local:</b> ${ativoData.Local || "-"}<br>
          <b>Status:</b> ${ativoData.StatusGateway || "-"}<br>
          <b>Última Visualização:</b> ${ajustarHorario(ativoData.UltimaVisualizacao)}
        `);

        ativoMarker.bindPopup(popup);
        markersGroup.current.addLayer(ativoMarker);
        console.log('🗺️ Ativo plotado com sucesso');
      }
      */

      // Plotar gateways com áreas de cobertura
      if (gatewayData && gatewayData.length > 0) {
        console.log('🗺️ Processando', gatewayData.length, 'gateways');
        gatewayData.forEach((gateway: IGatewayData, index: number) => {
          console.log(`🗺️ Processando gateway ${index + 1}:`, gateway.DeviceKey);
          console.log('🗺️ Gateway GW1:', gateway.GW1);
          console.log('🗺️ Gateway Distancia:', gateway.GW1?.Distancia);

          // Não plotar marcador do gateway - apenas processar área de cobertura
          /*
          if (gateway.Latitude && gateway.Longitude) {
            // Criar marcador do gateway com cor laranja
            const marker = L.marker([gateway.Latitude, gateway.Longitude], {
              icon: L.divIcon({
                className: 'custom-div-icon',
                html: `<div style="background-color: #ff7800; width: 16px; height: 16px; border-radius: 50%; border: 2px solid white; box-shadow: 0 2px 4px rgba(0,0,0,0.3);"></div>`,
                iconSize: [16, 16],
                iconAnchor: [8, 8]
              })
            });

            // Criar popup com informações detalhadas
            const popup = L.popup().setContent(`
              <b>Gateway:</b> ${gateway.DeviceKey}<br>
              <b>Organização:</b> ${gateway.Organizacao}<br>
              <b>Ativo:</b> ${gateway.Ativo}<br>
              <b>Método:</b> ${gateway.Metodo}<br>
              <b>Última Visualização:</b> ${ajustarHorario(gateway.LastSeen)}<br>
              ${gateway.GW1 ? `<b>Distância:</b> ${gateway.GW1.Distancia}m<br>` : ''}
              <b>Coordenadas:</b> ${gateway.Latitude.toFixed(6)}, ${gateway.Longitude.toFixed(6)}
            `);

            marker.bindPopup(popup);
            markersGroup.current?.addLayer(marker);
            console.log('🗺️ Gateway plotado:', gateway.DeviceKey);
          }
          */
        });
      }

      // Não plotar beacons - apenas processar gateways para área de cobertura
      /*
      // Plotar beacons
      if (beaconData && beaconData.length > 0) {
        beaconData.forEach((beacon: IBeaconData) => {
          if (beacon.Latitude && beacon.Longitude) {
            const marker = L.marker([beacon.Latitude, beacon.Longitude], {
              icon: L.divIcon({
                className: 'custom-div-icon',
                html: `<div style="background-color: #ff0000; width: 12px; height: 12px; border-radius: 50%; border: 2px solid white; box-shadow: 0 2px 4px rgba(0,0,0,0.3);"></div>`,
                iconSize: [12, 12],
                iconAnchor: [6, 6]
              })
            });

            const popup = L.popup().setContent(`
              <b>Beacon:</b> ${beacon.DeviceKey}<br>
              <b>Ativo:</b> ${beacon.Ativo}<br>
              <b>Organização:</b> ${beacon.Organizacao}<br>
              <b>Método:</b> ${beacon.Metodo}<br>
              <b>Última Visualização:</b> ${ajustarHorario(beacon.LastSeen)}<br>
              ${beacon.GW1 ? `<b>Distância:</b> ${beacon.GW1.Distancia}m<br>` : ''}
              <b>Coordenadas:</b> ${beacon.Latitude.toFixed(6)}, ${beacon.Longitude.toFixed(6)}
            `);

            marker.bindPopup(popup);
            markersGroup.current?.addLayer(marker);

            // Se há coordenadas aleatórias para beacon, plotar também
            if (beacon.LatitudeAleatoria && beacon.LongitudeAleatoria) {
              const randomMarker = L.marker([beacon.LatitudeAleatoria, beacon.LongitudeAleatoria], {
                icon: L.divIcon({
                  className: 'custom-div-icon',
                  html: `<div style="background-color: #ffff00; width: 10px; height: 10px; border-radius: 50%; border: 2px solid white; box-shadow: 0 2px 4px rgba(0,0,0,0.3);"></div>`,
                  iconSize: [10, 10],
                  iconAnchor: [5, 5]
                })
              });

              const randomPopup = L.popup().setContent(`
                <b>Localização Estimada (Beacon)</b><br>
                <b>Beacon:</b> ${beacon.DeviceKey}<br>
                <b>Método:</b> ${beacon.Metodo}<br>
                <b>Coordenadas:</b> ${beacon.LatitudeAleatoria.toFixed(6)}, ${beacon.LongitudeAleatoria.toFixed(6)}
              `);

              randomMarker.bindPopup(randomPopup);
              markersGroup.current?.addLayer(randomMarker);
            }
          }
        });
      }
      */

      // Não centralizar novamente - já foi feito nos bounds dos círculos
      /*
      // Centralizar mapa no ativo selecionado
      if (ativoData.Latitude && ativoData.Longitude && mapRef.current) {
        mapRef.current.setView([ativoData.Latitude, ativoData.Longitude], 18); // Zoom mais próximo
        console.log('🗺️ Mapa centralizado no ativo com zoom 18');
      }
      */

      // Criar legenda do mapa
      // createMapLegend(); // Removido - não exibir legenda

      console.log("🗺️ Dados plotados no mapa - Ativo selecionado + Gateways:", gatewayData.length, "Beacons:", beaconData.length);

      // Plotar gateways com áreas de cobertura
      gatewayData.forEach((gateway: IGatewayData, index: number) => {
        console.log(`🗺️ Processando gateway ${index + 1}:`, gateway.DeviceKey);
        console.log('🗺️ Gateway GW1:', gateway.GW1);
        console.log('🗺️ Gateway Distancia:', gateway.GW1?.Distancia);

        // Não plotar marcador do gateway - apenas processar área de cobertura
        /*
        if (gateway.Latitude && gateway.Longitude) {
          // Criar marcador do gateway com cor laranja
          const marker = L.marker([gateway.Latitude, gateway.Longitude], {
            icon: L.divIcon({
              className: 'custom-div-icon',
              html: `<div style="background-color: #ff7800; width: 16px; height: 16px; border-radius: 50%; border: 2px solid white; box-shadow: 0 2px 4px rgba(0,0,0,0.3);"></div>`,
              iconSize: [16, 16],
              iconAnchor: [8, 8]
            })
          });

          // Criar popup com informações detalhadas
          const popup = L.popup().setContent(`
            <b>Gateway:</b> ${gateway.DeviceKey}<br>
            <b>Organização:</b> ${gateway.Organizacao}<br>
            <b>Ativo:</b> ${gateway.Ativo}<br>
            <b>Método:</b> ${gateway.Metodo}<br>
            <b>Última Visualização:</b> ${ajustarHorario(gateway.LastSeen)}<br>
            ${gateway.GW1 ? `<b>Distância:</b> ${gateway.GW1.Distancia}m<br>` : ''}
            <b>Coordenadas:</b> ${gateway.Latitude.toFixed(6)}, ${gateway.Longitude.toFixed(6)}
          `);

          marker.bindPopup(popup);
          markersGroup.current?.addLayer(marker);
          console.log('🗺️ Gateway plotado:', gateway.DeviceKey);
        }
        */
      });

      // Criar área de cobertura baseada no primeiro gateway (se existir)
      if (vercirculos && gatewayData.length > 0 && gatewayData[0].GW1 && gatewayData[0].GW1.Distancia && ativoLat && ativoLng) {
        const gateway = gatewayData[0]; // Usar primeiro gateway
        console.log('🗺️ Criando círculo para gateway:', gateway.DeviceKey);
        console.log('🗺️ Distância:', gateway.GW1?.Distancia);
        console.log('🗺️ Coordenadas do ativo para círculo:', ativoLat, ativoLng);

        const distancia = parseFloat(gateway.GW1?.Distancia || '0');
        console.log('🗺️ Distância parseada:', distancia);

        if (!isNaN(distancia) && distancia > 0) {
          console.log('🗺️ Distância válida, criando círculo...');

          // Criar círculo de cobertura ao redor do ativo
          let circle: L.Circle;
          try {
            circle = L.circle([ativoLat, ativoLng], {
              radius: distancia * 3, // Aumentar 3x para boa visibilidade sem exagero
              color: '#0000FF', // Azul mais forte
              fillColor: '#0066cc',
              fillOpacity: 0.3, // Reduzir opacidade para menos obstrusivo
              weight: 2, // Borda mais fina
              opacity: 0.8, // Opacidade da borda
              interactive: true // Garantir que seja interativo
            });
            console.log('🗺️ ✅ Círculo criado com sucesso');
          } catch (circleError) {
            console.error('🗺️ ❌ Erro ao criar círculo:', circleError);
            return;
          }

          const circlePopup = L.popup().setContent(`
            <b>Área de Cobertura do Ativo</b><br>
            <b>Ativo:</b> ${ativoData.Ativo}<br>
            <b>Gateway:</b> ${gateway.DeviceKey}<br>
            <b>Raio:</b> ${distancia.toFixed(2)}m (mostrado 3x maior)<br>
            <b>Método:</b> ${gateway.Metodo}
          `);

          circle.bindPopup(circlePopup);

          console.log('🗺️ Círculo configurado:', {
            center: [ativoLat, ativoLng],
            radius: distancia * 3,
            originalRadius: distancia,
            color: '#0000FF',
            visible: true
          });

          // Adicionar círculo ao markersGroup e ao mapa PRIMEIRO
          try {
            markersGroup.current?.addLayer(circle);
            if (mapRef.current) {
              circle.addTo(mapRef.current);
            }
            console.log('🗺️ Círculo adicionado ao mapa');
            console.log('🗺️ markersGroup.current:', markersGroup.current);
            console.log('🗺️ mapRef.current:', mapRef.current);
            console.log('🗺️ Círculo criado:', circle);
            console.log('🗺️ Círculo bounds:', circle.getBounds());
            console.log('��️ Círculo radius:', circle.getRadius());
          } catch (addError) {
            console.error('🗺️ ❌ Erro ao adicionar círculo ao mapa:', addError);
          }

          // Centralizar o mapa nos bounds do círculo DEPOIS de adicionar
          try {
            if (mapRef.current && circle.getBounds) {
              console.log('🗺️ Centralizando mapa nos bounds do círculo...');

              // Aguardar um pouco para o círculo estar completamente renderizado
              setTimeout(() => {
                try {
                  const bounds = circle.getBounds();
                  console.log('🗺️ Bounds do círculo:', bounds);
                  if (mapRef.current) {
                    mapRef.current.fitBounds(bounds, {
                      padding: [50, 50], // Adiciona padding de 50px em todas as direções
                      maxZoom: 16 // Zoom menor para ver melhor o círculo pequeno
                    });
                  }
                  console.log('🗺️ Mapa centralizado nos bounds do círculo');
                } catch (boundsError) {
                  console.error('🗺️ ❌ Erro ao obter bounds do círculo:', boundsError);
                  // Fallback: centralizar apenas no ponto
                  if (ativoLat && ativoLng) {
                    mapRef.current?.setView([ativoLat, ativoLng], 16);
                  }
                }
              }, 200);
            }
          } catch (boundsError) {
            console.error('🗺️ ❌ Erro ao centralizar mapa:', boundsError);
          }

          // Adicionar uma estrela no centro da área de cobertura (no ativo)
          const star = L.marker([ativoLat, ativoLng], {
            icon: createStarIcon(),
            zIndexOffset: 1000 // Garantir que fique acima do círculo
          });

          const starPopup = L.popup().setContent(`
            <b>Centro da Área de Cobertura</b><br>
            <b>Ativo:</b> ${ativoData.Ativo}<br>
            <b>Gateway:</b> ${gateway.DeviceKey}<br>
            <b>Raio:</b> ${distancia.toFixed(2)}m<br>
            <b>Método:</b> ${gateway.Metodo}
          `);

          star.bindPopup(starPopup);
          markersGroup.current?.addLayer(star);
          console.log('🗺️ Estrela adicionada ao mapa');
          console.log('🗺️ Número final de camadas no markersGroup:', markersGroup.current?.getLayers().length);
          console.log(`🗺️ ✅ Círculo criado AO REDOR DO ATIVO ${ativoData.Ativo} com raio ${distancia}m baseado no gateway ${gateway.DeviceKey}`);
        } else {
          console.log('🗺️ Distância inválida:', distancia);
        }
      } else {
        console.log('🗺️ Círculos desabilitados ou dados insuficientes');
        console.log('🗺️ vercirculos:', vercirculos);
        console.log('🗺️ Primeiro gateway existe:', !!gatewayData[0]);
        console.log('🗺️ GW1 existe:', !!gatewayData[0]?.GW1);
        console.log('🗺️ Distancia existe:', !!gatewayData[0]?.GW1?.Distancia);
        console.log('🗺️ Coordenadas do ativo existem:', !!(ativoLat && ativoLng));
      }
    } catch (error) {
      console.error("Erro ao plotar dados no mapa:", error);
    }
  };

  // Função para incluir comentário
  const handleIncluirComentario = async () => {
    console.log('💬 Incluindo comentário:', newComment);
    if (selectedAlert && newComment) {
      const comentario = {
        IdUser: idemail, // ID do usuário atual
        IdPrismWorkflow: parseInt(selectedAlert.IdWorkFlow),
        Comments: newComment, // Inclui o texto do comentário
        DtCriacao: new Date().toISOString(),
        DtAlteracao: new Date().toISOString(),
      };

      try {
        const response = await fetch(
          `${backendUrl}/api/PrismWorkFlowUser`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(comentario),
          }
        );

        if (response.ok) {
          const responseJson = await response.json();

          // Buscar o nome do usuário pelo ID
          const userResponse = await fetch(`${backendUrl}/api/User/${idemail}`);
          if (userResponse.ok) {
            const userData = await userResponse.json();

            // Atualiza o estado dos comentários em tempo real
            setComents((prevComents) => [
              {
                ...responseJson,
                Comments: newComment, // Adiciona o texto do comentário enviado
                Name: userData?.Name || "Usuário não identificado", // Adiciona o nome do usuário
                DtCriacao: responseJson.DtCriacao || comentario.DtCriacao,
              },
              ...prevComents, // Mantém os comentários existentes
            ]);

            // Limpa o campo de comentário
            setNewComment("");
            alert("Comentário incluído com sucesso!");
          }
        }
      } catch (error) {
        // Erro silencioso
      }
    } else {
      alert("Comentário não pode estar vazio");
    }
  };

  const getMovimentacoesBaseColumns = (): ColumnDefinition[] => [
    {
      title: "Entrada",
      field: "tracking.TrackingDate",
      sorter: (a: any, b: any) => {
        const toTimestamp = (value: any): number => {
          if (!value) return 0;
          if (value instanceof Date) return value.getTime();
          if (typeof value === 'string') {
            const match = value.match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/);
            if (match) {
              const [, day, month, year, hour, minute, second] = match;
              return new Date(parseInt(year), parseInt(month) - 1, parseInt(day), parseInt(hour), parseInt(minute), parseInt(second)).getTime();
            }
            const date = new Date(value);
            return isNaN(date.getTime()) ? 0 : date.getTime();
          }
          return 0;
        };
        return toTimestamp(a) - toTimestamp(b);
      },
      width: 230,
      headerFilter: "input",
      headerFilterPlaceholder: "Filtrar Data...",
      formatter: (cell) => {
        const value = cell.getValue();
        if (!value) return "Sem data";
        if (value instanceof Date) return moment(value).format("DD/MM/YYYY HH:mm:ss");
        if (typeof value === 'string' && value.match(/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/)) return value;
        const date = moment(value);
        return date.isValid() ? date.format("DD/MM/YYYY HH:mm:ss") : "Sem data";
      },
    },
    {
      title: "Local",
      field: "place.Name",
      sorter: "string",
      width: 200,
      headerFilter: "input",
      headerFilterPlaceholder: "Filtrar Local...",
      formatter: (cell) => cell.getValue() || '-',
    },
    {
      title: "Item Associado",
      field: "ItemAssociado",
      sorter: "string",
      width: 150,
      headerFilter: "input",
      headerFilterPlaceholder: "Filtrar Item...",
      formatter: (cell) => cell.getValue() || '-',
    },
    {
      title: "Status",
      field: "InfoAdicional",
      sorter: "string",
      width: 180,
      headerFilter: "input",
      headerFilterPlaceholder: "Filtrar Status...",
      formatter: (cell) => {
        const value = cell.getValue();
        if (!value) return '-';
        const statusConfig: { [key: string]: { text: string; color: string } } = {
          'DentroDoLocal': { text: 'Dentro do Local', color: '#28a745' },
          'Localizado': { text: 'Localizado', color: '#ffc107' },
          'AtivoSemLeitura': { text: 'Ativo Sem Leitura', color: '#dc3545' },
          'DePassagem': { text: 'De Passagem', color: '#6c757d' }
        };
        const config = statusConfig[value];
        if (!config) return value;
        return `<div style="display: flex; align-items: center; gap: 8px;">
                  <div style="width: 12px; height: 12px; border-radius: 50%; background-color: ${config.color}; border: 1px solid ${config.color}; flex-shrink: 0;"></div>
                  <span>${config.text}</span>
                </div>`;
      },
    },
    {
      title: "Permanência",
      field: "tracking.Permanence",
      sorter: "string",
      width: 180,
      headerFilter: "input",
      headerFilterPlaceholder: "Filtrar Tempo...",
      formatter: (cell) => cell.getValue() || '-'
    },
  ];

  useEffect(() => {
    // Só inicializa se a aba for movimentações, a div existir e houver dados
    if (activeTab === 'movimentacoes' && movimentacoesDivRef.current && movimentacoes.length > 0) {

      const initializeMovimentacoesTable = async () => {
        // Se já existir uma instância, destrua (opcional, mas o Tabulator geralmente lida bem se recriar no mesmo div limpando o HTML)
        // if (movimentacoesTableRef.current) { ... }

        console.log("🔧 Inicializando Tabela de Movimentações");

        // 1. Obter nome da corporação para buscar configuração
        const corpObj = availableCorporations.find(c => c.id === selectedCorporation);
        const corporationName = corpObj ? corpObj.name : (selectedAtivo?.Corporacao || "");

        let colunasConfiguradas: any[] = [];

        // 2. Buscar configurações na API para MOVIMENTACOES
        if (corporationName) {
          try {
            const response = await httpClient.request({
              method: RequestMethod.GET,
              endpoint: `/api/labels/MOVIMENTACOES/${corporationName}`
            });

            if (response.success && response.payload) {
              colunasConfiguradas = response.payload;
              console.log("Configurações de colunas MOVIMENTACOES carregadas:", colunasConfiguradas);
            }
          } catch (error) {
            console.error("Erro ao carregar labels de movimentações:", error);
          }
        }

        // 3. Obter colunas base
        const baseColumns = getMovimentacoesBaseColumns();

        // 4. Merge: Aplicar títulos da API
        const finalColumns: ColumnDefinition[] = baseColumns.map(col => {
          const config = colunasConfiguradas.find(
            c => c.Field && col.field && c.Field.toLowerCase() === col.field.toLowerCase()
          );

          if (config && config.Title) {
            return { ...col, title: config.Title };
          }
          return col;
        });

        // Processamento prévio dos dados (ordenação)
        const processedData = [...movimentacoes]
          .filter(m => m && m.tracking && m.tracking.TrackingDate)
          .sort((a, b) => {
            // Função para converter TrackingDate para timestamp
            const toTimestamp = (value: any): number => {
              if (!value) return 0;
              if (value instanceof Date) return value.getTime();
              if (typeof value === 'string') {
                // Formato brasileiro: DD/MM/YYYY HH:mm:ss
                const match = value.match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/);
                if (match) {
                  const [, day, month, year, hour, minute, second] = match;
                  return new Date(
                    parseInt(year),
                    parseInt(month) - 1,
                    parseInt(day),
                    parseInt(hour),
                    parseInt(minute),
                    parseInt(second)
                  ).getTime();
                }
                // Tentar parsear como ISO
                const date = new Date(value);
                return isNaN(date.getTime()) ? 0 : date.getTime();
              }
              return 0;
            };

            const timestampA = toTimestamp(a.tracking.TrackingDate);
            const timestampB = toTimestamp(b.tracking.TrackingDate);
            return timestampB - timestampA; // Mais recente primeiro
          });

        // Inicializa a variável de filtrados com todos os dados iniciais
        setMovimentacoesFiltradas(processedData);

        if (!movimentacoesDivRef.current) {
          console.warn('⚠️ movimentacoesDivRef.current não está disponível');
          return;
        }

        movimentacoesTableRef.current = new Tabulator(movimentacoesDivRef.current, {
          data: processedData,
          layout: "fitData",
          height: "100%",
          movableColumns: true,
          persistenceID: "movimentacoesTableConfig",
          persistenceMode: "local",
          persistence: {
            columns: ["width", "visible"],
            sort: false,
            filter: false,
            group: false,
            page: false,
          },
          // AQUI usamos as colunas dinâmicas
          columns: finalColumns,
        });

        movimentacoesTableRef.current.on("dataFiltered", function (filters: any, rows: any[]) {
          const dadosAtuais = rows.map(row => row.getData());
          setMovimentacoesFiltradas(dadosAtuais);
        });
      };

      initializeMovimentacoesTable();
    }
  }, [activeTab, movimentacoes, selectedCorporation]);


  const getCardStyle = (chamado: IChamado) => {
    const isSelected = selectedAlert && selectedAlert.IdWorkFlow === chamado.IdWorkFlow;
    console.log('🎨 Aplicando estilo para chamado:', chamado.IdWorkFlow, 'selecionado:', isSelected);
    return {
      backgroundColor: isSelected ? '#e6f7ff' : '#f8f9fa',
      borderRadius: '8px',
      padding: '15px',
      marginBottom: '10px',
      color: '#000000',
      border: isSelected ? '1px solid #91d5ff' : '1px solid #dee2e6',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      boxShadow: isSelected ? '0 2px 8px rgba(0,123,255,0.15)' : '0 2px 4px rgba(0,0,0,0.05)'
    };
  };

  // Função para processar lista de ativos relacionados (baseada no grafanaativo.js)
  const processaListaDeAtivos = (listaDeAtivos: IAtivosModel[], corporacao: string): IAtivosModel[] => {
    console.log('🔍 processaListaDeAtivos - INÍCIO');
    console.log('📊 Total de ativos recebidos:', listaDeAtivos.length);
    console.log('🏢 Corporação para filtro:', corporacao);
    console.log('📋 Primeiros 3 ativos:', listaDeAtivos.slice(0, 3).map(a => ({
      IdPrism: a.IdPrism,
      Ativo: a.Ativo,
      CorpLocal: a.CorpLocal,
      DeviceId: a.DeviceId
    })));

    const listaFinal: IAtivosModel[] = [];
    const idsProcessados = new Set<number>();

    // Filtrar ativos pela corporação
    // TEMPORÁRIO: Desabilitar filtro por corporação para debug
    const ativosFiltrados = listaDeAtivos; // .filter(item => item.CorpLocal === corporacao || !item.CorpLocal);

    console.log('🔍 Ativos filtrados por corporação:', ativosFiltrados.length);
    console.log('📋 Ativos filtrados:', ativosFiltrados.map(a => ({
      IdPrism: a.IdPrism,
      Ativo: a.Ativo,
      CorpLocal: a.CorpLocal
    })));

    ativosFiltrados.forEach(item => {
      if (idsProcessados.has(item.IdPrism)) return;

      // Encontrar todos os ativos com o mesmo IdPrism
      const mesmosIdPrism = ativosFiltrados.filter(outro => outro.IdPrism === item.IdPrism);
      const primeiraOcorrencia = mesmosIdPrism[0];

      console.log(`🔍 Processando IdPrism ${item.IdPrism}:`, {
        totalMesmosIdPrism: mesmosIdPrism.length,
        primeiraOcorrencia: primeiraOcorrencia.Ativo,
        deviceId: primeiraOcorrencia.DeviceId
      });

      // Filtrar relacionados internos (mesmo IdPrism mas deviceid diferente)
      const relacionadosInternos = mesmosIdPrism.slice(1).filter(outro =>
        outro.DeviceId !== primeiraOcorrencia.DeviceId
      );

      console.log(`🔍 Relacionados internos para IdPrism ${item.IdPrism}:`, relacionadosInternos.length);

      let principal = primeiraOcorrencia;
      let relacionados: IAtivosModel[] = [];

      // Processar relacionados internos
      relacionadosInternos.forEach(outro => {
        // Usar comparação de datas como no grafanaativo.js (formato brasileiro)
        const dataOutro = outro.UltimaVisualizacao || '';
        const dataPrincipal = principal.UltimaVisualizacao || '';

        console.log(`🔍 Comparando datas para IdPrism ${item.IdPrism}:`, {
          outro: { ativo: outro.Ativo, data: dataOutro },
          principal: { ativo: principal.Ativo, data: dataPrincipal }
        });

        // Se a data do outro é mais recente, ele se torna o principal
        if (dataOutro > dataPrincipal) {
          relacionados.push(principal);
          principal = outro;
          console.log(`🔄 ${outro.Ativo} se tornou principal (data mais recente)`);
        } else {
          relacionados.push(outro);
          console.log(`🔄 ${principal.Ativo} permanece principal`);
        }

        // Combinar beacons se forem diferentes
        if (outro.IdBeacon !== principal.IdBeacon) {
          const beacons = new Set(principal.IdBeacon.split(','));
          beacons.add(outro.IdBeacon);
          principal.IdBeacon = Array.from(beacons).join(',');
        }
      });

      // Encontrar relacionados externos (mesmo IdPrism mas corporação diferente)
      const relacionadosExternos = listaDeAtivos.filter(outro =>
        outro.IdPrism === item.IdPrism &&
        outro.CorpLocal !== corporacao &&
        outro.CorpLocal
      );

      console.log(`🔍 Relacionados externos para IdPrism ${item.IdPrism}:`, relacionadosExternos.length);

      relacionados.push(...relacionadosExternos);

      // Adicionar campo relacionados ao principal
      principal.relacionados = relacionados;
      listaFinal.push(principal);
      idsProcessados.add(item.IdPrism);

      console.log(`✅ IdPrism ${item.IdPrism} processado - Principal: ${principal.Ativo}, Relacionados: ${relacionados.length}`);
    });

    console.log('🔍 processaListaDeAtivos - FIM');
    console.log('📊 Total de ativos únicos processados:', listaFinal.length);
    console.log('📋 Ativos finais:', listaFinal.map(a => ({
      IdPrism: a.IdPrism,
      Ativo: a.Ativo,
      Relacionados: a.relacionados?.length || 0
    })));

    return listaFinal;
  };

  const obterMapaAtivo = async (orgs?: string[]) => {
    startApiCall();
    try {
      console.log('🔍 obterMapaAtivo chamado com organizações:', orgs);

      // Garantir que o paginador esteja posicionado corretamente enquanto os dados carregam
      if (mainTableRef.current) {
        atualizarFooterTabela();
      }

      console.log('�� Fazendo requisição para API...');

      // Define o endpoint com base na presença de orgs
      const endpoint = orgs ? '/Gerenciamento/PowerBI/ObterAtivosByOrg' : '/Gerenciamento/PowerBI/ObterAtivos';

      // Cria um objeto URLSearchParams para construir a query string
      const queryParams = new URLSearchParams();
      if (dataSetNamePBI) {
        queryParams.append('datasetName', dataSetNamePBI);
      }

      if (orgs && orgs.length > 0) {
        orgs.forEach(org => {
          queryParams.append('organization', org.trim());
        });
      }

      // Concatena a query string ao endpoint
      const fullUrl = `${endpoint}?${queryParams.toString()}`;

      const response = await httpClient.request({
        method: RequestMethod.GET,
        endpoint: fullUrl,
      });

      if (response.success && response.payload) {
        console.log('✅ Dados carregados da API:', response.payload.length, 'ativos');
        console.log('🏢 Organizações nos dados:', Array.from(new Set(response.payload.map((item: any) => item.Organizacao))));
        console.log('🏢 Corporações nos dados:', Array.from(new Set(response.payload.map((item: any) => item.CorpLocal))));
        console.log('📊 Exemplo de dados:', response.payload.slice(0, 2));

        // Processar lista de ativos relacionados (baseado no grafanaativo.js)
        const corporacaoAtual = String(selectedCorporation || '');
        console.log('🔍 Corporação selecionada para processamento:', corporacaoAtual);

        // TEMPORÁRIO: Desabilitar processamento de ativos relacionados para debug
        const dadosProcessados = response.payload; // processaListaDeAtivos(response.payload, corporacaoAtual);
        console.log('🔄 Dados processados (DESABILITADO):', dadosProcessados.length, 'ativos únicos');

        // Aplica filtros do header antes de carregar (evita renderizar tudo e depois filtrar)
        console.log('🔍 Aplicando filtros do header...');
        // TEMPORÁRIO: Desabilitar filtros do header para debug
        const dadosFiltrados = dadosProcessados; // aplicarFiltrosHeaderNosDados(dadosProcessados);
        console.log('🔍 Dados após filtros do header (DESABILITADO):', dadosFiltrados.length, 'ativos');

        // Atualizar o estado com os novos dados
        setListaAtivo(dadosFiltrados);
        const novoTotal = dadosProcessados.length;
        setTotalRegistros(novoTotal);
        setRegistrosFiltrados(dadosFiltrados.length);

        // Atualizar a tabela se ela existir
        if (mainTableRef.current) {
          console.log('🔄 Atualizando dados da tabela...');
          mainTableRef.current.replaceData(dadosFiltrados);

          // Atualizar o rodapé
          atualizarFooterTabela(dadosFiltrados.length);
          console.log('✅ Tabela atualizada com sucesso');
        } else {
          console.warn('⚠️ mainTableRef.current não está disponível');
        }
      } else {
        throw new Error("Falha ao obter dados dos ativos");
      }
    } catch (error: any) {
      if (mainTableRef.current) {
        const footerCountEl = document.getElementById('footer-count') || mainTableRef.current.element.querySelector('#footer-count');
        const msg = `Erro ao carregar dados: ${error?.message || 'Erro desconhecido'}`;
        if (footerCountEl) {
          footerCountEl.innerHTML = `<span style='color: red'>${msg}</span>`;
        } else {
          // fallback para garantir que o usuário veja a mensagem sem destruir o paginador
          atualizarFooterTabela();
          const fc = document.getElementById('footer-count') || mainTableRef.current.element.querySelector('#footer-count');
          if (fc) fc.innerHTML = `<span style='color: red'>${msg}</span>`;
        }
      }
    } finally {
      endApiCall();
    }
  };

  // Adicionar função para verificar se é usuário Taggen
  const isTaggenUser = useMemo(() => {
    const isTaggen = emailUsuario?.toLowerCase().endsWith('@taggen.com.br') || false;
    console.log('👤 Verificando se é usuário Taggen:', emailUsuario, 'Resultado:', isTaggen);
    return isTaggen;
  }, [emailUsuario]);

  // Estado para controlar a exibição de círculos (sempre true por padrão)
  const [vercirculos, setVerCirculos] = useState(true);

  // Função para limpar apenas círculos e estrelas, mantendo o marcador do ativo
  const limparCirculos = () => {
    if (markersGroup.current) {
      // Em vez de clearLayers (que remove tudo), vamos remover apenas círculos e estrelas
      const layers = markersGroup.current.getLayers();
      const layersToRemove: L.Layer[] = [];

      layers.forEach((layer: L.Layer) => {
        // Nunca remover o marcador do ativo atual
        if (layer === currentAtivoMarkerRef.current) {
          return;
        }

        // Remover apenas círculos (L.Circle) e estrelas (marcadores com ícone de estrela)
        if (layer instanceof L.Circle) {
          layersToRemove.push(layer);
        } else if (layer instanceof L.Marker) {
          // Verificar se é uma estrela pelo ícone
          const marker = layer as L.Marker;
          const icon = marker.getIcon();
          if (icon && (icon as any).options && (icon as any).options.className === 'custom-star-icon') {
            layersToRemove.push(layer);
          }
        }
      });

      // Remover apenas os círculos e estrelas
      layersToRemove.forEach(layer => {
        markersGroup.current?.removeLayer(layer);
      });

      console.log(`🗺️ ${layersToRemove.length} círculos/estrelas removidos, mantendo marcador do ativo`);
    }
  };

  // useEffect para limpar círculos quando vercirculos for false
  useEffect(() => {
    if (!vercirculos && markersGroup.current) {
      limparCirculos();
    }
  }, [vercirculos]);

  // useEffect para limpar círculos quando vercirculos for desabilitado
  useEffect(() => {
    if (!vercirculos && markersGroup.current) {
      console.log('🗺️ Limpando círculos - vercirculos desabilitado');
      limparCirculos(); // Usar função que preserva o marcador do ativo
    }
  }, [vercirculos]);

  // Função para garantir posicionamento do paginador sem exibir contadores
  const atualizarFooterTabela = (_linhasFiltradas?: number) => {
    if (!mainTableRef.current) return;
    try {
      const footerP = document.getElementById('footer-paginator') || mainTableRef.current.element.querySelector('#footer-paginator');
      const footerEl = mainTableRef.current.element.querySelector('.tabulator-footer');
      if (footerP && footerEl) {
        const paginator = footerEl.querySelector('.tabulator-paginator');
        if (paginator && footerP !== paginator.parentElement) {
          footerP.innerHTML = '';
          footerP.appendChild(paginator);
        }
      }
    } catch (err) {
      console.warn('Erro ao posicionar paginador:', err);
    }
  };

  // Função para calcular distância entre coordenadas (fórmula de Haversine)
  const calcularDistancia = (lat1: number, lon1: number, lat2: number, lon2: number) => {
    const R = 6371; // Raio da Terra em km
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; // Distância em km
  };

  // Função para criar legenda no mapa (removida - não exibir legenda)
  /*
  const createMapLegend = () => {
    if (!mapRef.current) return;

    // Remover legenda existente se houver
    const existingLegend = document.querySelector('.map-legend');
    if (existingLegend) {
      existingLegend.remove();
    }

    // Criar elemento da legenda
    const legend = document.createElement('div');
    legend.className = 'map-legend';
    legend.style.cssText = `
      position: absolute;
      top: 10px;
      right: 10px;
      background: white;
      padding: 10px;
      border-radius: 5px;
      box-shadow: 0 2px 10px rgba(0,0,0,0.1);
      z-index: 1000;
      font-size: 12px;
      min-width: 200px;
    `;

    legend.innerHTML = `
      <h4 style="margin: 0 0 10px 0; font-size: 14px;">Legenda</h4>
      <div style="margin-bottom: 8px;">
        <span style="display: inline-block; width: 20px; height: 20px; background: #3388ff; margin-right: 8px; border-radius: 50%;"></span>
        <span>Ativo Selecionado</span>
      </div>
      <div style="margin-bottom: 8px;">
        <span style="display: inline-block; width: 16px; height: 16px; background: #ff7800; margin-right: 8px; border-radius: 50%;"></span>
        <span>Gateway</span>
      </div>
      <div style="margin-bottom: 8px;">
        <span style="display: inline-block; width: 12px; height: 12px; background: #ff0000; margin-right: 8px; border-radius: 50%;"></span>
        <span>Beacon</span>
      </div>
      <div style="margin-bottom: 8px;">
        <span style="display: inline-block; width: 20px; height: 20px; background: rgba(51, 136, 255, 0.2); margin-right: 8px; border: 2px solid #3388ff;"></span>
        <span>Área de Cobertura do Ativo</span>
      </div>
      <div style="margin-bottom: 8px;">
        <span style="display: inline-block; width: 20px; height: 20px; background: yellow; margin-right: 8px; border: 2px solid orange; border-radius: 50%; text-align: center; line-height: 16px; font-size: 10px; color: orange;">★</span>
        <span>Centro da Área (Ativo)</span>
      </div>
      <div style="margin-bottom: 8px;">
        <span style="display: inline-block; width: 14px; height: 14px; background: #ffff00; margin-right: 8px; border-radius: 50%;"></span>
        <span>Localização Estimada</span>
      </div>
    `;

    // Adicionar ao mapa
    mapRef.current.getContainer().appendChild(legend);
  };
  */

  // Função para criar ícone de estrela (baseado no MapLocais.tsx)
  const createStarIcon = () => {
    return L.divIcon({
      className: 'custom-star-icon',
      html: `<div style="
        width: 20px;
        height: 20px;
        background: yellow;
        border: 2px solid orange;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: bold;
        color: orange;
        box-shadow: 0 2px 4px rgba(0,0,0,0.3);
      ">★</div>`,
      iconSize: [20, 20],
      iconAnchor: [10, 10]
    });
  };

  // Inicializar o mapa apenas uma vez
  useEffect(() => {
    console.log('🗺️ useEffect de inicialização do mapa');
    if (!mapRef.current) {
      console.log('🗺️ Mapa ainda não inicializado');
      return;
    }

    console.log('🗺️ Inicializando markersGroup...');
    if (!markersGroup.current) {
      markersGroup.current = L.layerGroup().addTo(mapRef.current);
      console.log('🗺️ markersGroup criado:', markersGroup.current);
    }

    // Configurar o mapa
    mapRef.current.setMinZoom(5); // Zoom mínimo
    mapRef.current.setMaxZoom(20); // Zoom máximo (evita tiles cinzas)

    // Limpar apenas círculos e outras camadas temporárias quando o componente for desmontado.
    // Manter o marcador do ativo para que ele persista ao alternar entre abas ou fechar o painel.
    return () => {
      console.log('🗺️ Limpando camadas temporárias (círculos/estrelas)...');
      try {
        // Utiliza a função limparCirculos para remover somente círculos e ícones de estrela,
        // preservando o marcador principal do ativo. Isso evita que o marcador seja removido
        // quando o usuário fecha a aba ou muda para outra aba de detalhes.
        limparCirculos();
      } catch (err) {
        // Caso a função não esteja disponível por algum motivo, não limpar nada para manter marcadores.
        console.warn('⚠️ Falha ao limpar círculos/estrelas durante desmontagem:', err);
      }
    };
  }, [mapRef.current]); // Executar apenas quando o mapa for inicializado

  // Atualizar o mapa quando selectedAtivo mudar
  useEffect(() => {
    console.log('🗺️ useEffect - selectedAtivo mudou:', selectedAtivo?.Ativo);
    if (selectedAtivo && mapRef.current && markersGroup.current) {
      console.log('🗺️ Atualizando mapa com novo ativo...');

      // Não limpar marcadores - apenas limpar círculos e estrelas anteriores
      limparCirculos();
      console.log('🗺️ Círculos anteriores limpos (mantendo marcador do ativo)');

      // Não chamar plotGatewayAndBeaconData automaticamente aqui
      // O usuário deve clicar no marcador do ativo para ver os círculos
      console.log('🗺️ Ativo atualizado - clique no marcador para ver círculos de cobertura');
    }
  }, [selectedAtivo]);

  // Função para verificar se o mapa está completamente pronto
  const isMapReady = () => {
    return mapRef.current &&
      mapRef.current.getContainer() &&
      mapRef.current.getSize() &&
      mapRef.current.getSize().x > 0 &&
      mapRef.current.getSize().y > 0;
  };

  // Função para aguardar o mapa estar pronto
  const waitForMapReady = async (maxWait = 2000) => {
    const startTime = Date.now();
    while (!isMapReady() && (Date.now() - startTime) < maxWait) {
      console.log('🗺️ Aguardando mapa estar pronto...');
      await new Promise(resolve => setTimeout(resolve, 100));
    }
    return isMapReady();
  };


  const handleDownloadCsvMovimentacoes = () => {
    if (movimentacoesTableRef.current) {
      console.log('📥 Baixando CSV nativo do Tabulator');
      // "active" baixa apenas o que está filtrado/visível. 
      // Se quiser tudo, mude para "all".
      movimentacoesTableRef.current.download("csv", "movimentacoes.csv", { delimiter: ";" });
    } else {
      alert("Tabela não inicializada.");
    }
  };

  // 2. Excel via API (/Report/Excel)
  const getValueByPath = (obj: any, path: string) => {
    return path.split('.').reduce((o, i) => (o ? o[i] : null), obj);
  };

  const handleDownloadExcelMovimentacoes = async () => {
    if (movimentacoesFiltradas.length === 0) {
      alert("Não há dados para exportar.");
      return;
    }

    if (!movimentacoesTableRef.current) {
      alert("Tabela não inicializada.");
      return;
    }

    console.log('📥 Preparando dados para API Excel com títulos dinâmicos...');

    // 1. Obter colunas visíveis da tabela atual
    const visibleColumns = movimentacoesTableRef.current.getColumns()
      .filter((col: ColumnComponent) => col.isVisible());

    // 2. Mapear dados usando os títulos dinâmicos da tabela
    const dadosFormatados = movimentacoesFiltradas.map((row) => {
      const rowData: Record<string, any> = {};

      visibleColumns.forEach((col: ColumnComponent) => {
        const def = col.getDefinition();
        const field = def.field; // ex: "tracking.TrackingDate"
        const title = def.title; // ex: "Data/Entrada" (ou o valor configurado na API)

        if (field && title) {
          // Busca o valor no objeto de dados usando o caminho do campo
          let value = getValueByPath(row, field);

          // Formatação específica para datas se necessário (pois o Excel da API espera string ou raw)
          if (field === "tracking.TrackingDate" && value) {
            if (value instanceof Date) value = moment(value).format("DD/MM/YYYY HH:mm:ss");
            // Se já for string formatada, mantém
          }

          rowData[title] = value || "";
        }
      });
      return rowData;
    });

    try {
      // Chamada à API
      const response = await fetch(`${backendUrl}/Report/Excel`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dadosFormatados)
      });

      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `Movimentacoes_${moment().format('YYYYMMDD_HHmm')}.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        console.log('✅ Excel baixado com sucesso via API');
      } else {
        console.error('❌ Erro na API de Excel:', response.statusText);
        alert("Erro ao gerar o arquivo Excel pelo servidor.");
      }

    } catch (error) {
      console.error('❌ Erro na exportação Excel:', error);
      alert("Erro ao tentar exportar para Excel.");
    }
  };

  const handleRefreshMovimentacoes = async () => {
    if (selectedAtivo) {
      console.log('🔄 Atualizando movimentações...');
      await obterMovimentacoesAtivo(
        selectedAtivo.IdAtivo,
        selectedAtivo.IdOrganizacao,
        selectedAtivo.Corporacao,
        selectedAtivo.Organizacao,
        selectedAtivo.Ativo
      );
    }
  };

  return (
    <div className="d-flex" style={{ position: "relative" }}>
      <div style={{ width: sidebarVisible ? "80%" : "100%", transition: "0.3s" }}>
        <h1 className="ui header">
          {isVwco ? "Tabela de Beacons" : "Tabela de Ativos"}
        </h1>
        <div style={{ marginBottom: "10px", display: "flex", alignItems: "center", gap: "10px" }}>
          {/* Filtros Globais */}
          <div style={{ flex: 1, maxWidth: "600px" }}>
            <FiltroGlobal />
          </div>

          {/* Botões existentes */}
          <button
            onClick={handleSettingsClick}
            style={{ padding: "10px 20px", cursor: "pointer" }}
            className="ui button primary"
            disabled={configButtonDisabled}
            title={configButtonDisabled ? "Aguardando carregamento das APIs..." : ""}
          >
            ⚙️ Configurações
          </button>
          <button
            onClick={handleClearFilters}
            style={{ padding: "10px 20px", cursor: "pointer" }}
            className="ui button secondary"
          >
            🗑️ Limpar Filtros
          </button>
          <button
            onClick={handleDownloadCsv}
            style={{
              padding: "10px 20px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
            className="ui button secondary"
          >
            <i className="ui icon arrow alternate circle down outline"></i>
            Download CSV
          </button>
          <button
            onClick={exportTableToExcel}
            style={{
              padding: "10px 20px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
            className="ui button secondary"
          >
            <i className="ui icon file excel outline"></i>
            Download Excel
          </button>
          <button
            onClick={() => obterMapaAtivo(selectedOrganizations)}
            style={{
              padding: "10px 20px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
            className="ui button secondary"
          >
            <i className="ui icon refresh"></i>
            Atualizar
          </button>
        </div>
        {/* Tabela */}
        <div ref={tableRef}></div>
      </div>
      {/* Sidebar de Configurações */}
      {sidebarVisible && (
        <div className="sidebar-config">

          {/* Botão de Fechar (X) com classe CSS */}
          <i
            className="ui icon close sidebar-close-btn"
            onClick={() => setSidebarVisible(false)}
            title="Fechar configurações"
          />

          {/* Header ajustado: Removido 'inverted' para controlar via CSS */}
          <h4 className="ui grey header sidebar-header">
            <i className="ui cog icon"></i> Configurações da Tabela
          </h4>

          <div className="config-content" ref={configTableRef}></div>

          <button className="ui primary button" onClick={applyConfigChanges}>
            <i className="ui save icon"></i> Aplicar
          </button>
        </div>
      )}
      {detailsVisible && selectedAtivo && (
        <div className="details-panel">
          <div className="header">
            <h3>Detalhes do Ativo</h3>
            <i
              className="ui close icon close-icon"
              onClick={() => {
                setDetailsVisible(false);
                clearRowSelection();

                // Não limpar o marcador - apenas esconder o painel de detalhes
                // O marcador permanece no mapa para referência futura
                console.log('🔍 Fechando painel de detalhes, mantendo marcador no mapa');
              }}
            />
          </div>

          {/* Menu de abas */}
          <div className="tab-container">
            <button
              className={`tab-button ${activeTab === 'mapa' ? 'active' : ''}`}
              onClick={() => handleTabChange('mapa')}
            >
              <i className="map icon"></i>
              Mapa
            </button>
            <button
              className={`tab-button ${activeTab === 'alertas' ? 'active' : ''}`}
              onClick={() => handleTabChange('alertas')}
            >
              <i className="bell icon"></i>
              Alertas
            </button>
            <button
              className={`tab-button ${activeTab === 'movimentacoes' ? 'active' : ''}`}
              onClick={() => handleTabChange('movimentacoes')}
            >
              <i className="history icon"></i>
              Movimentações
            </button>
            <button
              className={`tab-button ${activeTab === 'documentos' ? 'active' : ''}`}
              onClick={() => handleTabChange('documentos')}
            >
              <i className="file archive icon"></i>
              Documentos
            </button>
          </div>

          {/* Conteúdo das abas */}
          <div className={`tab-content ${activeTab === 'mapa' ? 'active' : ''}`}>
            {activeTab === 'mapa' && (
              <div className="map-container">
                <MapContainer
                  center={[-21.97686767578125, -47.851436614990234]} // Centro padrão
                  zoom={15} // Zoom padrão
                  minZoom={5}
                  maxZoom={20}
                  style={{ height: '100%', width: '100%' }}
                  ref={(map) => {
                    if (map) {
                      console.log('🗺️ Mapa criado');
                      mapRef.current = map;

                      // Criar escala se ainda não existir
                      if (!scaleControlRef.current) {
                        console.log('🗺️ Criando controle de escala...');
                        scaleControlRef.current = L.control.scale({
                          imperial: false,
                          position: 'bottomright'
                        });
                        mapRef.current.addControl(scaleControlRef.current);
                        console.log('🗺️ Controle de escala adicionado');
                      }

                      // Se o markersGroup já existir (talvez de um mapa anterior), associe-o ao novo mapa.
                      if (markersGroup.current) {
                        console.log('🗺️ markersGroup já existe, adicionando ao novo mapa...');
                        markersGroup.current.addTo(map);
                      } else {
                        // Caso contrário, crie um novo markersGroup
                        console.log('🗺️ Criando markersGroup...');
                        markersGroup.current = L.layerGroup().addTo(map);
                        console.log('🗺️ markersGroup criado');
                      }
                    }
                  }}
                >
                  {/* Camada padrão - Satélite Google com configurações otimizadas */}
                  <TileLayer
                    url="https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
                    maxZoom={20}
                    maxNativeZoom={20}
                    tileSize={256}
                    zoomOffset={0}
                    updateWhenZooming={false}
                    keepBuffer={2}
                    updateWhenIdle={true}
                    eventHandlers={{
                      tileerror: (e) => {
                        console.warn('⚠️ Erro ao carregar tile:', e);
                      }
                    }}
                  />

                  {/* Controle de Camadas Base com configurações otimizadas */}
                  <LayersControl position="topright">
                    <LayersControl.BaseLayer checked name="Satélite Google">
                      <TileLayer
                        url="https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
                        maxZoom={20}
                        maxNativeZoom={20}
                        tileSize={256}
                        zoomOffset={0}
                        updateWhenZooming={false}
                        keepBuffer={2}
                        updateWhenIdle={true}
                      />
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name="Viário Google">
                      <TileLayer
                        url="https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
                        maxZoom={20}
                        maxNativeZoom={20}
                        tileSize={256}
                        zoomOffset={0}
                        updateWhenZooming={false}
                        keepBuffer={2}
                        updateWhenIdle={true}
                      />
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name="OpenStreetMap">
                      <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        maxZoom={18}
                        maxNativeZoom={18}
                        tileSize={256}
                        zoomOffset={0}
                        updateWhenZooming={false}
                        keepBuffer={2}
                        updateWhenIdle={true}
                      />
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name="Mapa Escuro">
                      <TileLayer
                        url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
                        maxZoom={18}
                        maxNativeZoom={18}
                        tileSize={256}
                        zoomOffset={0}
                        updateWhenZooming={false}
                        keepBuffer={2}
                        updateWhenIdle={true}
                      />
                    </LayersControl.BaseLayer>
                  </LayersControl>

                  {/* Menu de Configurações */}
                  <div className="leaflet-top leaflet-right" style={{ marginTop: '72px', marginRight: '2px', zIndex: 1002 }}>
                    <div className="leaflet-control leaflet-bar">
                      <button
                        title="Configurações do Mapa"
                        onClick={() => {
                          const configMenu = document.getElementById('configMenuMapAtivo');
                          if (configMenu) {
                            configMenu.style.display = configMenu.style.display === 'block' ? 'none' : 'block';
                          }
                        }}
                        style={{
                          width: '40px', height: '40px', display: 'flex', alignItems: 'center',
                          justifyContent: 'center', fontSize: '1.2em', backgroundColor: 'white',
                          border: '2px solid rgba(0,0,0,0.2)', borderRadius: '4px', cursor: 'pointer'
                        }}
                      >
                        ⚙️
                      </button>
                    </div>
                  </div>

                  {/* Menu de Configurações */}
                  <div
                    id="configMenuMapAtivo"
                    style={{
                      display: 'none', position: 'absolute', top: '132px', right: '10px',
                      backgroundColor: 'white', color: 'black', padding: '15px', borderRadius: '5px',
                      boxShadow: '0 0 10px rgba(0,0,0,0.2)', zIndex: 1001, width: '220px'
                    }}
                  >
                    <h4 style={{ marginTop: 0, color: 'black', marginBottom: '10px' }}>Config. Mapa</h4>
                    <div style={{ marginBottom: '10px' }}>
                      <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                        <input
                          type="checkbox"
                          checked={vercirculos}
                          onChange={() => setVerCirculos(!vercirculos)}
                          style={{ marginRight: '8px' }}
                        />
                        Círculos de Cobertura
                      </label>
                    </div>
                  </div>
                </MapContainer>
              </div>
            )}
          </div>

          <div className={`tab-content ${activeTab === 'alertas' ? 'active' : ''}`}>
            {activeTab === 'alertas' && (
              <div className="alert-details">
                <div className="alert-list">
                  {chamadosAtivo.length > 0 ? (
                    [...chamadosAtivo]
                      .sort((a, b) => new Date(b.DataCriacao).getTime() - new Date(a.DataCriacao).getTime())
                      .map((chamado, index) => (
                        <div
                          key={index}
                          className={`alert-card ${selectedAlert && selectedAlert.IdWorkFlow === chamado.IdWorkFlow ? 'selected' : ''}`}
                          onClick={() => setSelectedAlert(chamado)}
                        >
                          <div className="alert-header">
                            <div className="alert-icons">
                              {chamado.Status ? (
                                <i className="ui small green check icon" title="Concluído" />
                              ) : (
                                <i className="ui small clock icon" title="Em andamento" />
                              )}
                              {(() => {
                                switch (parseInt(chamado.IdAlertLevel)) {
                                  case 1:
                                  case 2:
                                    return <i className="ui small yellow exclamation triangle icon" title="Alerta Baixo" />;
                                  case 3:
                                    return <i className="ui small orange exclamation triangle icon" title="Alerta Médio" />;
                                  case 4:
                                  case 5:
                                    return <i className="ui small red exclamation triangle icon" title="Alerta Alto" />;
                                  default:
                                    return <i className="ui small gray exclamation triangle icon" title="Nível não definido" />;
                                }
                              })()}
                            </div>
                            <span className="alert-date">
                              {moment(chamado.DataCriacao).format('DD/MM/YYYY HH:mm')}
                            </span>
                          </div>
                          <div className="alert-title">{chamado.Assunto}</div>
                          <div className="alerta-info">
                            <div>Requisitante: {chamado.UsuarioOwner}</div>
                            <div>Responsável: {chamado.UsuarioResponsible}</div>
                          </div>
                          <div className="alert-footer">
                            <span>Chamado: {chamado.Chamado ? `#${chamado.Chamado}` : 'Não registrado'}</span>
                            <div className="alert-actions">
                              <div className="comment-count">
                                <i className="ui icon comment alternate" title="Interações" />
                                {(chamado.TotalRecords ?? 0) > 0 && (
                                  <div className="count-badge">{chamado.TotalRecords}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                  ) : (
                    <div className="no-alerts">
                      Não há alertas registrados para este ativo
                    </div>
                  )}
                </div>

                <div className="comment-section">
                  {selectedAlert && (
                    <div className="comment-box">
                      <h4>Comentários</h4>
                      <div className="comments">
                        {coments
                          .sort((a, b) => new Date(b.DtCriacao).getTime() - new Date(a.DtCriacao).getTime()) // Ordena do mais recente para o mais antigo
                          .map((comentario, index) => (
                            <div key={index} className="comment">
                              <div>{comentario.Comments}</div>
                              <div>
                                Por {comentario.Name || 'Usuário não identificado'} em{' '}
                                {moment(comentario.DtCriacao).format('DD/MM/YYYY HH:mm')}
                              </div>
                            </div>
                          ))}
                      </div>
                      <textarea
                        placeholder="Digite seu comentário..."
                        value={newComment}
                        onChange={(e) => setNewComment(e.target.value)}
                        disabled={selectedAlert.Status === true} // Desabilita o campo se o status for true
                      />

                      <div style={{ display: "flex", gap: "8px", marginTop: "8px", justifyContent: "center" }}>
                        <button
                          className="ui primary button"
                          onClick={() => {
                            if (selectedAlert.Status !== true) {
                              handleIncluirComentario();
                            }
                          }}
                          disabled={selectedAlert.Status === true}
                          style={{
                            cursor: selectedAlert.Status === true ? "not-allowed" : "pointer",
                            backgroundColor: selectedAlert.Status === true ? "#d3d3d3" : "",
                            padding: "8px 12px", // metade do tamanho
                            fontSize: "0.9em",
                          }}
                        >
                          {selectedAlert.Status === true ? "Chamado Fechado" : "Adicionar Comentário"}
                        </button>
                        {selectedAlert?.IdUsuarioResponsible === idemail && !selectedAlert?.Status && (
                          <button
                            title={coments.length === 0 ? "É necessário incluir ao menos um comentário para fechar o alerta." : ""}
                            style={{
                              padding: "8px 12px",
                              backgroundColor: "#fd2600",
                              color: "#fff",
                              border: "none",
                              borderRadius: "5px",
                              fontSize: "0.9em",
                              transition: "opacity 0.3s",
                              cursor: coments.length === 0 ? "not-allowed" : "pointer",
                              opacity: coments.length === 0 ? 0.6 : 1,
                            }}
                            disabled={coments.length === 0}
                            onClick={() => handleFecharChamado(parseInt(selectedAlert.IdWorkFlow))}
                          >
                            Fechar Chamado
                          </button>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>{activeTab === 'movimentacoes' && (
            <div className="tab-content active">
              <div className="movimentacoes-container">

                {/* --- BARRA DE BOTÕES DE EXPORTAÇÃO --- */}
                <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px' }}>

                  {/* Semáforo de Sincronização */}
                  {(() => {
                    // Função para converter data brasileira para Date
                    const parseDataBrasileira = (dataStr: string | null): Date | null => {
                      if (!dataStr) return null;
                      const match = dataStr.match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/);
                      if (match) {
                        const [, day, month, year, hour, minute, second] = match;
                        return new Date(
                          parseInt(year),
                          parseInt(month) - 1,
                          parseInt(day),
                          parseInt(hour),
                          parseInt(minute),
                          parseInt(second)
                        );
                      }
                      const date = new Date(dataStr);
                      return isNaN(date.getTime()) ? null : date;
                    };

                    // Função auxiliar para normalizar data para DD/MM/YYYY HH:mm:ss
                    const normalizarDataParaDDMMYYYY = (dataStr: string | null): string | null => {
                      if (!dataStr) return null;

                      // Se já está no formato DD/MM/YYYY HH:mm:ss, verificar se está correto
                      const matchDDMM = dataStr.match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/);
                      if (matchDDMM) {
                        const [, day, month, year] = matchDDMM;
                        // Se o primeiro número > 12, provavelmente está em DD/MM/YYYY
                        // Se o segundo número > 12, provavelmente está em MM/DD/YYYY
                        if (parseInt(day) > 12) {
                          // Já está em DD/MM/YYYY
                          return dataStr;
                        } else if (parseInt(month) > 12) {
                          // Está em MM/DD/YYYY, converter para DD/MM/YYYY
                          const [, monthOrig, dayOrig, yearOrig, hour, minute, second] = matchDDMM;
                          return `${dayOrig}/${monthOrig}/${yearOrig} ${hour}:${minute}:${second}`;
                        } else {
                          // Ambos <= 12, assumir DD/MM/YYYY (formato brasileiro)
                          return dataStr;
                        }
                      }

                      // Tentar parsear como DD/MM/YYYY primeiro
                      let parsed = parseDataBrasileira(dataStr);
                      if (parsed) {
                        const dia = parsed.getDate().toString().padStart(2, '0');
                        const mes = (parsed.getMonth() + 1).toString().padStart(2, '0');
                        const ano = parsed.getFullYear();
                        const hora = parsed.getHours().toString().padStart(2, '0');
                        const minuto = parsed.getMinutes().toString().padStart(2, '0');
                        const segundo = parsed.getSeconds().toString().padStart(2, '0');
                        return `${dia}/${mes}/${ano} ${hora}:${minuto}:${segundo}`;
                      }

                      // Se não conseguir, tentar como Date ISO
                      const date = new Date(dataStr);
                      if (!isNaN(date.getTime())) {
                        const dia = date.getDate().toString().padStart(2, '0');
                        const mes = (date.getMonth() + 1).toString().padStart(2, '0');
                        const ano = date.getFullYear();
                        const hora = date.getHours().toString().padStart(2, '0');
                        const minuto = date.getMinutes().toString().padStart(2, '0');
                        const segundo = date.getSeconds().toString().padStart(2, '0');
                        return `${dia}/${mes}/${ano} ${hora}:${minuto}:${segundo}`;
                      }

                      return null;
                    };

                    // Obter a Última Visualização: usar do popup se disponível, senão usar do selectedAtivo
                    let ultimaVisualizacaoParaComparacao: string | null = null;
                    if (ultimaVisualizacaoPopup) {
                      ultimaVisualizacaoParaComparacao = normalizarDataParaDDMMYYYY(ultimaVisualizacaoPopup);
                    } else if (selectedAtivo?.UltimaVisualizacao) {
                      ultimaVisualizacaoParaComparacao = normalizarDataParaDDMMYYYY(selectedAtivo.UltimaVisualizacao);
                    }

                    // Encontrar o CurrentLastSeen mais recente
                    let currentLastSeenMaisRecente: string | null = null;
                    if (movimentacoes.length > 0) {
                      const lastSeens = movimentacoes
                        .map(m => m.CurrentLastSeen)
                        .filter(ls => ls !== null && ls !== undefined) as string[];

                      console.log('🔍 CurrentLastSeen encontrados:', lastSeens.length, 'valores', lastSeens);

                      if (lastSeens.length > 0) {
                        // Ordenar por data e pegar o mais recente
                        const lastSeensComData = lastSeens
                          .map(ls => {
                            const parsed = parseDataBrasileira(ls);
                            return { str: ls, date: parsed };
                          })
                          .filter(item => item.date !== null)
                          .sort((a, b) => b.date!.getTime() - a.date!.getTime());

                        console.log('🔍 CurrentLastSeen ordenados:', lastSeensComData.map(item => ({ str: item.str, timestamp: item.date!.getTime() })));

                        if (lastSeensComData.length > 0) {
                          currentLastSeenMaisRecente = lastSeensComData[0].str;
                          console.log('✅ CurrentLastSeen mais recente:', currentLastSeenMaisRecente, 'timestamp:', lastSeensComData[0].date!.getTime());
                        }
                      }
                    }

                    console.log('🔍 Última Visualização para comparação:', ultimaVisualizacaoParaComparacao);

                    if (!ultimaVisualizacaoParaComparacao || !currentLastSeenMaisRecente) {
                      console.log('⚠️ Semáforo não exibido - dados faltando');
                      console.log('  - ultimaVisualizacaoParaComparacao:', ultimaVisualizacaoParaComparacao);
                      console.log('  - currentLastSeenMaisRecente:', currentLastSeenMaisRecente);
                      return null;
                    }

                    const dataPopup = parseDataBrasileira(ultimaVisualizacaoParaComparacao);
                    const dataCurrentLastSeen = parseDataBrasileira(currentLastSeenMaisRecente);

                    console.log('🔍 Data Última Visualização parseada:', dataPopup, 'timestamp:', dataPopup?.getTime());
                    console.log('🔍 Data CurrentLastSeen parseada:', dataCurrentLastSeen, 'timestamp:', dataCurrentLastSeen?.getTime());

                    if (!dataPopup || !dataCurrentLastSeen) {
                      console.log('⚠️ Erro ao parsear datas');
                      return null;
                    }

                    // Função para formatar tempo de forma legível
                    const formatarTempoLegivel = (minutos: number): string => {
                      if (minutos === 0) return '0 min';

                      const dias = Math.floor(minutos / (24 * 60));
                      const horasRestantes = Math.floor((minutos % (24 * 60)) / 60);
                      const minutosRestantes = minutos % 60;

                      const partes: string[] = [];

                      if (dias > 0) {
                        partes.push(`${dias} dia${dias > 1 ? 's' : ''}`);
                      }
                      if (horasRestantes > 0) {
                        partes.push(`${horasRestantes}h`);
                      }
                      if (minutosRestantes > 0 && dias === 0) {
                        // Só mostrar minutos se não tiver dias (para não ficar muito longo)
                        partes.push(`${minutosRestantes} min`);
                      }

                      return partes.join(' e ');
                    };

                    // Calcular diferença em minutos
                    // CurrentLastSeen é mais recente, então subtraímos Última Visualização de CurrentLastSeen
                    const diferencaMs = dataCurrentLastSeen.getTime() - dataPopup.getTime();
                    const diferencaMinutos = Math.floor(Math.abs(diferencaMs) / (1000 * 60));

                    console.log('🔍 Diferença calculada:', diferencaMs, 'ms =', diferencaMinutos, 'minutos');

                    // Determinar cor do semáforo e texto
                    let cor = '#dc3545'; // Vermelho (padrão)
                    let texto = '';
                    if (diferencaMinutos <= 5) {
                      cor = '#28a745'; // Verde
                      texto = 'Sincronizado';
                    } else if (diferencaMinutos <= 30) {
                      cor = '#ffc107'; // Amarelo
                      const tempoFormatado = formatarTempoLegivel(diferencaMinutos);
                      texto = `Sincronizado a: ${tempoFormatado}`;
                    } else {
                      cor = '#dc3545'; // Vermelho
                      const tempoFormatado = formatarTempoLegivel(diferencaMinutos);
                      texto = `Sincronizado a: ${tempoFormatado}`;
                    }

                    return (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <div style={{
                          width: '24px',
                          height: '24px',
                          borderRadius: '50%',
                          backgroundColor: cor,
                          border: `2px solid ${cor}`,
                          boxShadow: '0 0 6px rgba(0,0,0,0.4)',
                          flexShrink: 0
                        }} title={`Sincronização: Diferença de ${diferencaMinutos} minuto${diferencaMinutos !== 1 ? 's' : ''} entre Última Visualização (${ultimaVisualizacaoParaComparacao}) e CurrentLastSeen mais recente (${currentLastSeenMaisRecente})`} />
                        <span style={{ fontSize: '12px', color: '#666' }}>
                          {texto}
                        </span>
                      </div>
                    );
                  })()}

                  <div style={{ display: 'flex', gap: '10px' }}>
                    <button
                      className="ui button blue"
                      onClick={handleRefreshMovimentacoes}
                      title="Atualizar dados de movimentação"
                    >
                      <i className="sync icon"></i> Atualizar
                    </button>

                    <button
                      className="ui button secondary"
                      onClick={handleDownloadCsvMovimentacoes}
                      disabled={movimentacoes.length === 0}
                      title="Exportar dados visíveis para CSV"
                    >
                      <i className="file alternate outline icon"></i> Exportação para CSV
                    </button>
                    <button
                      className="ui button green"
                      onClick={handleDownloadExcelMovimentacoes}
                      disabled={movimentacoes.length === 0}
                      title="Gerar relatório Excel via Servidor"
                    >
                      <i className="file excel outline icon"></i> Exportação para Excel
                    </button>
                  </div>
                </div>
                {movimentacoes.length > 0 ? (
                  <div className="tabulator-container" style={{
                    height: "500px",
                    marginBottom: "20px",
                    overflowX: "auto"
                  }}>
                    <div ref={movimentacoesDivRef}></div>
                  </div>
                ) : (
                  <div className="no-movimentacoes">
                    Não há movimentações registradas para este ativo
                  </div>
                )}
              </div>
            </div>
          )}
          <div className={`tab-content ${activeTab === 'documentos' ? 'active' : ''}`}>
            {activeTab === 'documentos' && selectedAtivo && (
              <GerenciadorArquivos
                corporacao={(() => {
                  if (selectedCorporation && availableCorporations) {
                    const corp = availableCorporations.find(c => c.id === selectedCorporation);
                    return corp ? corp.name : selectedAtivo.Corporacao;
                  }
                  return selectedAtivo.Corporacao;
                })()}
                organizacao={selectedAtivo.Organizacao}
                idEntidade={selectedAtivo.IdPrism}
                tipoDiretorio="Ativos"
                backendUrl={backendUrl || ""}
                isActive={activeTab === 'documentos'}
              />
            )}
          </div>
        </div>
      )}
    </div>

  );
};



export default AtivoMapaTable;

